function initLongmouthTheme() {
  const root = document.querySelector(".longmouth-theme");
  if (!root) return;
  let footerBackHomeLabel = "back to world";

  function isMobileDeviceLike() {
    const userAgent = navigator.userAgent || "";
    const platform = navigator.platform || "";
    const hasCoarsePointer = window.matchMedia("(pointer: coarse)").matches;
    const hasNoHover = window.matchMedia("(hover: none)").matches;
    const hasAnyCoarsePointer = window.matchMedia("(any-pointer: coarse)").matches;
    return (
      /Android|iPad|iPhone|iPod|Mobile/i.test(userAgent)
      || (platform === "MacIntel" && navigator.maxTouchPoints > 1)
      || (navigator.maxTouchPoints > 0 && (hasCoarsePointer || hasAnyCoarsePointer) && hasNoHover)
    );
  }

  const forceMobileDeviceLayout = isMobileDeviceLike();
  root.classList.toggle("is-mobile-device", forceMobileDeviceLayout);

  let waitlistSignupConfig = {
    klaviyoCompanyId: String((window.lmShop && window.lmShop.waitlistKlaviyoCompanyId) || "").trim(),
    klaviyoListId: String((window.lmShop && window.lmShop.waitlistKlaviyoListId) || "").trim(),
  };

  function initSiteSettingsBridge() {
    const settingsNode = root.querySelector("#longmouth-site-settings");
    if (!settingsNode) return;

    const data = settingsNode.dataset;
    const siteTitle = data.siteTitle || "";
    waitlistSignupConfig = {
      klaviyoCompanyId: String(
        data.waitlistKlaviyoCompanyId
          || (window.lmShop && window.lmShop.waitlistKlaviyoCompanyId)
          || ""
      ).trim(),
      klaviyoListId: String(
        data.waitlistKlaviyoListId
          || (window.lmShop && window.lmShop.waitlistKlaviyoListId)
          || ""
      ).trim(),
    };

    const titleNode = root.querySelector("#long-text");
    if (titleNode && siteTitle) {
      titleNode.textContent = siteTitle;
    }

    const setMenuLabel = (selector, value) => {
      const button = root.querySelector(selector);
      if (!button || !value) return;

      const labelNodes = button.querySelectorAll(".menu__item-text, .menu__item-text-hvr");
      labelNodes.forEach((node) => {
        node.textContent = value;
      });
    };

    setMenuLabel("#shop__button", data.menuLabelShop);
    setMenuLabel('[data-open-modal="mailinglist-modal"]', data.menuLabelWaitlist);
    setMenuLabel('[data-open-modal="contact-modal"]', data.menuLabelContact);
    setMenuLabel("#otherstuff__button", data.menuLabelPolicy);
    setMenuLabel("#home__button-footer", data.menuLabelBackHome);
    footerBackHomeLabel = data.menuLabelBackHome || "back to world";

    const contactHeading = root.querySelector("#contact-modal h1");
    if (contactHeading && data.contactHeading) contactHeading.textContent = data.contactHeading;

    const contactLink = root.querySelector("#contact-modal .goth-link");
    if (contactLink && data.contactEmail) {
      contactLink.textContent = data.contactEmail;
      contactLink.href = `mailto:${data.contactEmail}`;
    }

    const socialLinks = root.querySelectorAll("#contact-modal .socials__container a[data-social-fallback]");
    const socialValues = {
      youtube: data.youtubeUrl,
      tiktok: data.tiktokUrl,
      instagram: data.instagramUrl,
    };
    socialLinks.forEach((link) => {
      const key = link.dataset.socialFallback;
      const value = key ? socialValues[key] : "";
      if (value) link.href = value;
    });

    const waitlistHeading = root.querySelector("#mailinglist-modal h1");
    if (waitlistHeading && data.waitlistHeading) waitlistHeading.textContent = data.waitlistHeading;

    const waitlistSuccess = root.querySelector("#mailinglist-modal [data-waitlist-success]");
    if (waitlistSuccess) {
      waitlistSuccess.textContent = data.waitlistSuccessText || "Please check your email for confirmation";
    }

    const policyLabel = root.querySelector("#mailinglist-modal .readpolicy");
    if (policyLabel) {
      const policyText = data.waitlistPolicyPrefix || "here's our";
      const policyLinkText = data.waitlistPolicyLinkText || "privacy policy";
      const policyLink = policyLabel.querySelector("a");
      policyLabel.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
          node.textContent = `${policyText} `;
        }
      });
      if (policyLink) {
        policyLink.textContent = policyLinkText;
      }
    }

  }

  initSiteSettingsBridge();

  function initContactSocialsSectionBridge() {
    const socialsSource = root.querySelector("#longmouth-contact-socials") || document.querySelector("#longmouth-contact-socials");
    const socialsContainer = root.querySelector("#contact-modal .socials__container");
    if (!socialsSource || !socialsContainer) return;

    const socialItems = Array.from(
      socialsSource.querySelectorAll(".longmouth-contact-social-item")
    );
    if (!socialItems.length) return;

    const fragment = document.createDocumentFragment();

    socialItems.forEach((item) => {
      const title = (item.dataset.title || "Social link").trim();
      const link = (item.dataset.link || "").trim();
      const icon = (item.dataset.icon || "").trim();
      if (!title || !link || !icon) return;

      const anchor = document.createElement("a");
      anchor.href = link;
      anchor.target = "_blank";
      anchor.rel = "noopener";
      anchor.className = "w-inline-block social-link";
      anchor.setAttribute("aria-label", title);
      anchor.setAttribute("title", title);

      const image = document.createElement("img");
      image.src = icon;
      image.loading = "lazy";
      image.alt = title;
      image.className = "socials-icon social-icon";

      anchor.appendChild(image);
      fragment.appendChild(anchor);
    });

    if (!fragment.childNodes.length) return;
    socialsContainer.innerHTML = "";
    socialsContainer.appendChild(fragment);
  }

  initContactSocialsSectionBridge();

  function wireContactSocialsEditorSync() {
    if (!(window.Shopify && window.Shopify.designMode)) return;
    if (root.dataset.contactSocialsEditorSyncBound === "true") return;

    const resync = () => {
      initContactSocialsSectionBridge();
    };

    document.addEventListener("shopify:section:load", resync);
    document.addEventListener("shopify:section:reorder", resync);
    document.addEventListener("shopify:block:select", resync);
    document.addEventListener("shopify:block:deselect", resync);
    root.dataset.contactSocialsEditorSyncBound = "true";
  }

  wireContactSocialsEditorSync();

  function initGalleryBreakpointReload() {
    if (window.Shopify && window.Shopify.designMode) return;

    const galleryBreakpoint = window.matchMedia("(max-width: 1024px)");
    let currentMode = forceMobileDeviceLayout || galleryBreakpoint.matches ? "mobile" : "desktop";

    const onModeChange = (event) => {
      const nextMode = forceMobileDeviceLayout || event.matches ? "mobile" : "desktop";
      if (nextMode === currentMode) return;
      currentMode = nextMode;
      window.location.reload();
    };

    if (typeof galleryBreakpoint.addEventListener === "function") {
      galleryBreakpoint.addEventListener("change", onModeChange);
    } else if (typeof galleryBreakpoint.addListener === "function") {
      galleryBreakpoint.addListener(onModeChange);
    }
  }

  initGalleryBreakpointReload();

  function initHorizontalGalleryScroll() {
    const scroller = root.querySelector(".horizontal-scroll-wrapper");
    if (!scroller) return;

    let targetScrollLeft = scroller.scrollLeft;
    const ease = 0.1;
    let isScrolling = false;

    function smoothScroll() {
      if (!isScrolling) return;

      const delta = targetScrollLeft - scroller.scrollLeft;
      scroller.scrollLeft += delta * ease;

      if (Math.abs(delta) > 0.5) {
        requestAnimationFrame(smoothScroll);
      } else {
        scroller.scrollLeft = targetScrollLeft;
        isScrolling = false;
      }
    }

    window.addEventListener(
      "wheel",
      function (event) {
        const exempt = event.target.closest(".dropdown-scroll, .scroll-exempt, .product-list, #longmouth-product-drawer-content");
        if (exempt) return;

        if (event.deltaY === 0) return;

        event.preventDefault();

        targetScrollLeft += event.deltaY;

        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScroll));

        if (isScrolling) return;

        isScrolling = true;
        smoothScroll();
      },
      { passive: false }
    );
  }

  initHorizontalGalleryScroll();

  function waitForHomeGalleryMediaReady() {
    const galleryImages = Array.from(root.querySelectorAll("[data-longmouth-gallery] .gallery-item__image"));
    const galleryVideos = Array.from(root.querySelectorAll("[data-longmouth-gallery] video"));
    if (!galleryImages.length && !galleryVideos.length) return Promise.resolve();

    const waitForPaint = () =>
      new Promise((resolve) => {
        requestAnimationFrame(() => {
          requestAnimationFrame(resolve);
        });
      });

    const waitForImage = (img) =>
      new Promise((resolve) => {
        const finish = () => {
          if (typeof img.decode === "function" && img.complete && img.naturalWidth > 0) {
            img.decode().catch(() => {}).finally(() => {
              waitForPaint().then(resolve);
            });
            return;
          }

          waitForPaint().then(resolve);
        };

        if (img.complete) {
          finish();
          return;
        }

        const onDone = () => {
          img.removeEventListener("load", onDone);
          img.removeEventListener("error", onDone);
          finish();
        };

        img.addEventListener("load", onDone, { once: true });
        img.addEventListener("error", onDone, { once: true });
      });

    const waitForVideo = (video) =>
      new Promise((resolve) => {
        const finish = () => {
          waitForPaint().then(resolve);
        };

        if (video.readyState >= 2) {
          finish();
          return;
        }

        const onDone = () => {
          video.removeEventListener("loadeddata", onDone);
          video.removeEventListener("error", onDone);
          finish();
        };

        video.addEventListener("loadeddata", onDone, { once: true });
        video.addEventListener("error", onDone, { once: true });
      });

    return Promise.all([...galleryImages.map(waitForImage), ...galleryVideos.map(waitForVideo)]);
  }

  function waitForPageLoadComplete() {
    if (document.readyState === "complete") return Promise.resolve();

    return new Promise((resolve) => {
      window.addEventListener("load", resolve, { once: true });
    });
  }

  const menuCover = root.querySelector("#menu__loader-overlay");
  if (menuCover) {
    const menuCoverMode = menuCover.getAttribute("data-menu-loader-mode") || "hide_on_load";
    const homeGalleryMediaReady = waitForHomeGalleryMediaReady();
    let menuCoverHideTimer = null;

    const waitForDeferredScriptsReady = () => {
      if (window.lmDeferredScriptsReady) return Promise.resolve();

      return new Promise((resolve) => {
        const onScriptsReady = () => {
          document.removeEventListener("lm:deferred-scripts-ready", onScriptsReady);
          resolve();
        };

        document.addEventListener("lm:deferred-scripts-ready", onScriptsReady);
      });
    };

    const waitForMenuCoverReady = () =>
      Promise.all([waitForDeferredScriptsReady(), waitForPageLoadComplete(), homeGalleryMediaReady]);

    const showMenuCover = () => {
      if (menuCoverHideTimer) {
        clearTimeout(menuCoverHideTimer);
        menuCoverHideTimer = null;
      }

      menuCover.hidden = false;
      menuCover.style.display = "flex";
      menuCover.style.opacity = "1";
      menuCover.style.transition = "";
      menuCover.style.visibility = "visible";
      menuCover.style.pointerEvents = "auto";
    };

    const hideMenuCover = () => {
      menuCover.style.transition = "opacity 0.3s cubic-bezier(0.33, 1, 0.68, 1)";
      menuCover.style.opacity = "0";
      menuCover.style.pointerEvents = "none";
      menuCoverHideTimer = window.setTimeout(() => {
        menuCover.hidden = true;
        menuCover.style.display = "none";
        menuCover.style.visibility = "hidden";
        menuCoverHideTimer = null;
      }, 300);
    };

    if (menuCoverMode === "hide") {
      menuCover.hidden = true;
      menuCover.style.display = "none";
    } else if (menuCoverMode === "hide_on_load") {
      showMenuCover();
      waitForMenuCoverReady().then(hideMenuCover);
    } else {
      showMenuCover();
    }

    window.addEventListener("pageshow", (event) => {
      if (!event.persisted || menuCoverMode !== "hide_on_load") return;

      showMenuCover();
      waitForMenuCoverReady().then(hideMenuCover);
    });
  }

  const views = root.querySelectorAll("[data-view]");
  const modals = root.querySelectorAll(".modals__wrapper > [id]");
  const modalIds = new Set(Array.from(modals).map((modal) => modal.id).filter(Boolean));
  const viewNames = new Set(Array.from(views).map((view) => view.getAttribute("data-view")).filter(Boolean));
  const productPanel = root.querySelector("#product__panel");
  const productDrawerContent = root.querySelector("#longmouth-product-drawer-content");
  const productCards = root.querySelectorAll(".product-list__item[data-id]");
  const policyTabButtons = root.querySelectorAll("[data-policy-tab]");
  const policyTabPanes = root.querySelectorAll("[data-policy-pane]");
  const policyTabIds = new Set(
    Array.from(policyTabPanes)
      .map((pane) => pane.getAttribute("data-policy-pane"))
      .filter(Boolean)
  );
  const menuWrap = root.querySelector(".menu__wrap");
  const menuBackWrap = root.querySelector(".menu-back__wrap");
  const homeButtonWrap = root.querySelector("#home__button");
  const cartCountNodes = root.querySelectorAll(".cart_count");
  const cartWrapper = root.querySelector(".cart__wrapper");
  const cartTrigger = root.querySelector("[data-longmouth-open-cart]");
  const cartDropdown = root.querySelector(".mini-cart_dropdown");
  const cartDropdownList = root.querySelector(".mini-cart_dropdown-list");
  const cartItemsContainer = root.querySelector("[data-cart-items]");
  const cartTotalNode = root.querySelector("[data-cart-total]");
  const cartFormNode = root.querySelector("[data-cart-form]");
  const cartEmptyNode = root.querySelector("[data-cart-empty]");
  const cartErrorNode = root.querySelector("[data-cart-error]");
  const cartContinueNode = root.querySelector("[data-cart-continue]");
  const pendingCartLineKeys = new Set();
  const SHOP_FADE_DURATION_MS = 150;
  let shopHideTimer = null;
  let loadedProductCache = {};
  let navigationToken = 0;

  const sizeChartDataMap = new Map();
  function parseMaybeJson(value) {
    if (typeof value !== "string") return value;
    const trimmed = value.trim();
    if (!trimmed) return value;
    if (trimmed[0] !== "{" && trimmed[0] !== "[") return value;
    try {
      return JSON.parse(trimmed);
    } catch (e) {
      return value;
    }
  }

  function normalizeSizeChartData(rawData) {
    if (!rawData || typeof rawData !== "object") return null;

    const normalized = {
      sizes: parseMaybeJson(rawData.sizes),
      rows: parseMaybeJson(rawData.rows),
      unit: typeof rawData.unit === "string" ? rawData.unit : "in"
    };

    if (!Array.isArray(normalized.sizes) && typeof normalized.sizes === "string") {
      normalized.sizes = normalized.sizes
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    }

    if (!Array.isArray(normalized.rows)) {
      normalized.rows = [];
    }

    if (!Array.isArray(normalized.sizes)) {
      normalized.sizes = [];
    }

    return normalized;
  }

  productCards.forEach((card) => {
    const handle = card.getAttribute("data-product-handle");
    const dataStr = card.getAttribute("data-size-chart-data");
    if (handle && dataStr) {
      try {
        const parsed = JSON.parse(dataStr);
        const normalized = normalizeSizeChartData(parsed);
        if (normalized) sizeChartDataMap.set(handle, normalized);
      } catch (e) {}
    }
  });

  function formatMoney(cents) {
    const value = (Number(cents || 0) / 100) || 0;
    const fmt = (window.lmShop && window.lmShop.moneyFormat) || "${{amount}}";
    function withDelimiters(n, precision, thousands, decimal) {
      const str = Math.abs(n).toFixed(precision);
      const parts = str.split(".");
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      return (n < 0 ? "-" : "") + parts.join(decimal);
    }
    return fmt
      .replace("{{amount}}", withDelimiters(value, 2, ",", "."))
      .replace("{{amount_no_decimals}}", withDelimiters(value, 0, ",", "."))
      .replace("{{amount_with_comma_separator}}", withDelimiters(value, 2, ".", ","))
      .replace("{{amount_no_decimals_with_comma_separator}}", withDelimiters(value, 0, ".", ","))
      .replace("{{amount_with_apostrophe_separator}}", withDelimiters(value, 2, "'", "."));
  }

  function normalizeKlaviyoProfileProperties(rawProperties) {
    if (!rawProperties || typeof rawProperties !== "object") return null;

    const normalized = {};
    Object.entries(rawProperties).forEach(([key, value]) => {
      const safeKey = String(key || "").trim();
      if (!safeKey) return;
      if (value === null || typeof value === "undefined") return;

      if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed) return;
        normalized[safeKey] = trimmed.slice(0, 500);
        return;
      }

      if (typeof value === "number" || typeof value === "boolean") {
        normalized[safeKey] = value;
        return;
      }

      normalized[safeKey] = String(value).trim().slice(0, 500);
    });

    return Object.keys(normalized).length ? normalized : null;
  }

  async function trackKlaviyoEventByEmail(email, eventName, eventProperties) {
    const companyId = waitlistSignupConfig.klaviyoCompanyId;
    if (!companyId) {
      throw new Error("klaviyo_config_missing");
    }

    const safeEventName = String(eventName || "").trim();
    if (!safeEventName) {
      throw new Error("klaviyo_event_name_missing");
    }

    const endpoint = `https://a.klaviyo.com/client/events/?company_id=${encodeURIComponent(companyId)}`;
    const normalizedProperties = normalizeKlaviyoProfileProperties(eventProperties) || {};

    const payload = {
      data: {
        type: "event",
        attributes: {
          properties: normalizedProperties,
          metric: {
            data: {
              type: "metric",
              attributes: {
                name: safeEventName,
              },
            },
          },
          profile: {
            data: {
              type: "profile",
              attributes: {
                email,
              },
            },
          },
        },
      },
    };

    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: "2024-10-15",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const details = await response.text().catch(() => "");
      throw new Error(`klaviyo_event_failed_${response.status}:${details.slice(0, 200)}`);
    }
  }

  async function submitWaitlistViaKlaviyo(email, profileProperties) {
    const companyId = waitlistSignupConfig.klaviyoCompanyId;
    const listId = waitlistSignupConfig.klaviyoListId;

    if (!companyId || !listId) {
      throw new Error("klaviyo_config_missing");
    }

    const normalizedProperties = normalizeKlaviyoProfileProperties(profileProperties);
    const profileAttributes = { email };
    if (normalizedProperties) {
      profileAttributes.properties = normalizedProperties;
    }

    const endpoint = `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`;
    const payload = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Website",
          profile: {
            data: {
              type: "profile",
              attributes: profileAttributes
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: listId
            }
          }
        }
      }
    };

    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: "2024-10-15",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const details = await response.text().catch(() => "");
      throw new Error(`klaviyo_submit_failed_${response.status}:${details.slice(0, 200)}`);
    }
  }

  const WAITLIST_COOLDOWN_MS = 30000;
  const WAITLIST_COOLDOWN_KEY = "longmouth_waitlist_cooldown_until";
  const SIGNUP_FIELDS_SELECTOR = 'label[for], input[type="email"], [data-waitlist-submit], button[type="submit"], input[type="submit"], .readpolicy';

  function getWaitlistCooldownRemainingMs() {
    if (!window.localStorage) return 0;
    const until = Number(window.localStorage.getItem(WAITLIST_COOLDOWN_KEY) || 0);
    if (!Number.isFinite(until) || until <= 0) return 0;
    return Math.max(0, until - Date.now());
  }

  function setWaitlistCooldownNow() {
    if (!window.localStorage) return;
    window.localStorage.setItem(WAITLIST_COOLDOWN_KEY, String(Date.now() + WAITLIST_COOLDOWN_MS));
  }

  function formatCooldownMessage(remainingMs) {
    const remainingSeconds = Math.max(1, Math.ceil(remainingMs / 1000));
    return `please wait ${remainingSeconds}s before submitting another email.`;
  }

  function isGenericSignupErrorText(text) {
    const normalized = String(text || "").trim().toLowerCase();
    return !normalized || normalized === "unable to submit right now.";
  }

  function getSignupErrorMessage(error, fallbackText) {
    const fallback = String(fallbackText || "").trim();
    const defaultMessage = "we couldn't submit your email right now. please check your connection and try again.";

    if (!error) {
      return isGenericSignupErrorText(fallback) ? defaultMessage : fallback;
    }

    const errorMessage = String(error.message || "");

    if (errorMessage === "notify_email_missing") {
      return "please enter a valid email address.";
    }

    if (errorMessage === "klaviyo_config_missing") {
      return "email signup is temporarily unavailable due to a setup issue. please try again later.";
    }

    if (errorMessage.startsWith("klaviyo_submit_failed_")) {
      const statusToken = errorMessage.slice("klaviyo_submit_failed_".length).split(":")[0];
      const status = Number(statusToken);

      if (status === 400 || status === 422) {
        return "please enter a valid email address.";
      }

      if (status === 429) {
        return "too many attempts. please wait a moment and try again.";
      }

      if (status >= 500) {
        return "signup service is temporarily unavailable. please try again in a moment.";
      }

      if (status === 401 || status === 403 || status === 404) {
        return "email signup is temporarily unavailable. please try again later.";
      }
    }

    const lower = errorMessage.toLowerCase();
    if (!navigator.onLine || lower.includes("failed to fetch") || lower.includes("network")) {
      return "network issue detected. please check your connection and try again.";
    }

    return isGenericSignupErrorText(fallback) ? defaultMessage : fallback;
  }

  function clearSignupCooldownTimer(form) {
    if (!form || !form.__signupCooldownTimer) return;
    window.clearTimeout(form.__signupCooldownTimer);
    form.__signupCooldownTimer = null;
  }

  function clearSignupCooldownTicker(form) {
    if (!form || !form.__signupCooldownTicker) return;
    window.clearInterval(form.__signupCooldownTicker);
    form.__signupCooldownTicker = null;
  }

  function startSignupCooldownTicker(form, errorNode, defaultErrorText) {
    if (!form || !errorNode) return;

    clearSignupCooldownTicker(form);

    const tick = () => {
      const remainingMs = getWaitlistCooldownRemainingMs();

      if (remainingMs <= 0) {
        clearSignupCooldownTicker(form);
        if (String(errorNode.textContent || "").trim().startsWith("please wait ")) {
          errorNode.textContent = defaultErrorText;
          errorNode.hidden = true;
        }
        return;
      }

      if (form.dataset.signupCompleted === "true") {
        return;
      }

      errorNode.textContent = formatCooldownMessage(remainingMs);
      errorNode.hidden = false;
    };

    tick();

    if (getWaitlistCooldownRemainingMs() > 0) {
      form.__signupCooldownTicker = window.setInterval(tick, 1000);
    }
  }

  function restoreSignupFields(form, successNode, errorNode, defaultErrorText) {
    if (!form) return;
    form.dataset.signupCompleted = "false";

    form.querySelectorAll(SIGNUP_FIELDS_SELECTOR).forEach((node) => {
      node.hidden = false;
      node.style.display = "";
    });

    if (successNode) successNode.hidden = true;
    if (errorNode) {
      errorNode.hidden = true;
      if (typeof defaultErrorText === "string") {
        errorNode.textContent = defaultErrorText;
      }
    }
  }

  function scheduleSignupFieldsRestore(form, successNode, errorNode, defaultErrorText) {
    if (!form) return;

    clearSignupCooldownTimer(form);
    const remainingMs = getWaitlistCooldownRemainingMs();

    if (remainingMs <= 0) {
      restoreSignupFields(form, successNode, errorNode, defaultErrorText);
      return;
    }

    form.__signupCooldownTimer = window.setTimeout(() => {
      if (!form.isConnected) return;
      restoreSignupFields(form, successNode, errorNode, defaultErrorText);
    }, remainingMs + 50);
  }

  function replaceSignupFieldsWithSuccess(form, successNode) {
    if (!form) return;
    form.dataset.signupCompleted = "true";

    form
      .querySelectorAll(SIGNUP_FIELDS_SELECTOR)
      .forEach((node) => {
        node.hidden = true;
        node.style.display = "none";
      });

    if (successNode) {
      successNode.hidden = false;
    }
  }

  function initWaitlistSignupForm() {
    const modal = root.querySelector("#mailinglist-modal");
    if (!modal) return;

    const form = modal.querySelector("[data-waitlist-form]") || modal.querySelector("form");
    if (!form) return;

    const success = modal.querySelector("[data-waitlist-success]");
    const error = modal.querySelector("[data-waitlist-error]");
    const emailInput = form.querySelector('input[name="contact[email]"]');
    const submitButton = form.querySelector("[data-waitlist-submit]")
      || form.querySelector('button[type="submit"]')
      || form.querySelector('input[type="submit"]');
    const defaultErrorText = error ? error.textContent : "we couldn't submit your email right now. please try again.";

    scheduleSignupFieldsRestore(form, success, error, defaultErrorText);
    startSignupCooldownTicker(form, error, defaultErrorText);

    const resetStatus = () => {
      if (form.dataset.signupCompleted === "true") {
        if (getWaitlistCooldownRemainingMs() <= 0) {
          restoreSignupFields(form, success, error, defaultErrorText);
          startSignupCooldownTicker(form, error, defaultErrorText);
          return;
        }
        if (success) success.hidden = false;
        if (error) error.hidden = true;
        return;
      }

      if (success) success.hidden = true;
      if (error) {
        error.hidden = true;
        error.textContent = defaultErrorText;
      }

      startSignupCooldownTicker(form, error, defaultErrorText);
    };

    const runSignup = async () => {
      if (form.dataset.signupCompleted === "true") {
        if (getWaitlistCooldownRemainingMs() > 0) return true;
        restoreSignupFields(form, success, error, defaultErrorText);
      }

      resetStatus();

      const email = String(emailInput?.value || "").trim();
      if (!email) {
        if (error) {
          error.textContent = getSignupErrorMessage(new Error("notify_email_missing"), defaultErrorText);
          error.hidden = false;
        }
        return false;
      }

      const cooldownRemaining = getWaitlistCooldownRemainingMs();
      if (cooldownRemaining > 0) {
        if (error) {
          error.textContent = formatCooldownMessage(cooldownRemaining);
          error.hidden = false;
        }
        startSignupCooldownTicker(form, error, defaultErrorText);
        return false;
      }

      setProductFormSubmitting(form, true);

      let submitted = false;
      let submitError = null;

      try {
        await submitWaitlistViaKlaviyo(email);
        submitted = true;
      } catch (klaviyoError) {
        submitError = klaviyoError;
        console.error("Klaviyo waitlist submit failed.", klaviyoError);
      }

      if (submitted) {
        setWaitlistCooldownNow();
        replaceSignupFieldsWithSuccess(form, success);
        scheduleSignupFieldsRestore(form, success, error, defaultErrorText);
        startSignupCooldownTicker(form, error, defaultErrorText);
        form.reset();
      } else if (error) {
        error.textContent = getSignupErrorMessage(submitError, defaultErrorText);
        error.hidden = false;
      }

      setProductFormSubmitting(form, false);
      return submitted;
    };

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      runSignup();
    });

    if (submitButton) {
      submitButton.addEventListener("click", (event) => {
        event.preventDefault();
        runSignup();
      });
    }

    root.querySelectorAll('[data-open-modal="mailinglist-modal"]').forEach((button) => {
      button.addEventListener("click", resetStatus);
    });
  }

  function initEventBarDismiss() {
    const eventBar = root.querySelector(".event-bar");
    if (!eventBar) return;

    eventBar.style.transitionTimingFunction = eventBar.dataset.eventBarCloseEasing || "ease";

    const dismissKey = "longmouth_event_bar_dismissed";
    const isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
    const forceEventBar = isThemeEditor || (new URLSearchParams(window.location.search).get("lm_event_bar") === "1");

    if (forceEventBar && window.localStorage) {
      window.localStorage.removeItem(dismissKey);
    }

    if (!forceEventBar && window.localStorage && window.localStorage.getItem(dismissKey) === "true") {
      eventBar.remove();
      const existingClose = eventBar.parentElement && eventBar.parentElement.querySelector("[data-event-bar-close]");
      if (existingClose) existingClose.remove();
      return;
    }

    const closeButton = eventBar.parentElement && eventBar.parentElement.querySelector("[data-event-bar-close]");
    if (!closeButton) return;

    const removeEventBar = () => {
      eventBar.remove();
      if (closeButton.parentElement) {
        closeButton.remove();
      }
    };

    const scheduleRemove = (animation) => {
      if (animation === "none") {
        removeEventBar();
        return;
      }

      const onTransitionEnd = (event) => {
        if (event.target !== eventBar) return;
        eventBar.removeEventListener("transitionend", onTransitionEnd);
        removeEventBar();
      };

      eventBar.addEventListener("transitionend", onTransitionEnd);
      window.setTimeout(() => {
        eventBar.removeEventListener("transitionend", onTransitionEnd);
        removeEventBar();
      }, 600);
    };

    closeButton.addEventListener("click", () => {
      if (!forceEventBar && window.localStorage) {
        window.localStorage.setItem(dismissKey, "true");
      }
      const animation = eventBar.dataset.eventBarCloseAnimation || "fade";
      eventBar.classList.add("is-dismissing");
      scheduleRemove(animation);
    });
  }

  function setPolicyImagesEager() {
    const policyWrap = root.querySelector(".policy__wrap");
    if (!policyWrap) return;

    policyWrap.querySelectorAll("img").forEach((img) => {
      const existingWrap = img.parentElement && img.parentElement.classList.contains("policy-image-loader")
        ? img.parentElement
        : null;
      if (existingWrap && existingWrap.parentElement) {
        existingWrap.parentElement.insertBefore(img, existingWrap);
        existingWrap.remove();
      }

      img.setAttribute("loading", "eager");
      if (!img.hasAttribute("decoding")) {
        img.setAttribute("decoding", "async");
      }

      const host = img.parentElement;
      if (!host) return;

      host.classList.add("policy-image-loader-host");

      const clearLoading = () => {
        host.classList.remove("is-loading");
        img.classList.remove("policy-image-loading");
      };

      if (img.complete && img.naturalWidth > 0) {
        clearLoading();
      } else {
        host.classList.add("is-loading");
        img.classList.add("policy-image-loading");
        img.addEventListener("load", clearLoading, { once: true });
        img.addEventListener("error", clearLoading, { once: true });
      }
    });
  }

  function showView(name) {
    const viewToken = navigationToken;

    views.forEach((view) => {
      const viewName = view.getAttribute("data-view");
      const isHomeView = viewName === "home";
      const isTarget = viewName === name;
      const shouldStayVisible = isHomeView || isTarget;

      if (viewName === "shop") {
        if (isTarget) {
          if (shopHideTimer) {
            clearTimeout(shopHideTimer);
            shopHideTimer = null;
          }

          view.hidden = false;
          // Shop fade-in needs one paint at opacity:0 before toggling .show.
          view.classList.remove("show");
          window.requestAnimationFrame(() => {
            if (navigationToken !== viewToken) return;
            if (view.hidden) return;
            view.classList.add("show");
          });
          return;
        }

        view.classList.remove("show");
        if (shopHideTimer) clearTimeout(shopHideTimer);
        shopHideTimer = window.setTimeout(() => {
          if (navigationToken !== viewToken) return;
          if (view.classList.contains("show")) return;
          view.hidden = true;
        }, SHOP_FADE_DURATION_MS);
        return;
      }

      view.hidden = !shouldStayVisible;

      if (!isTarget) {
        view.classList.remove("show");
        return;
      }

      view.classList.add("show");
    });

    if (menuWrap) {
      menuWrap.hidden = name !== "home";
      menuWrap.style.display = name === "home" ? "flex" : "none";
    }

    if (menuBackWrap) {
      menuBackWrap.hidden = name === "home";
      menuBackWrap.style.display = name === "home" ? "none" : "flex";
    }

    if (name !== "shop") {
      closeCurrentLightbox();
      closeProductDrawer();
    }

    const policyWrap = root.querySelector(".policy__wrap");
    if (policyWrap) {
      policyWrap.classList.toggle("show", name === "policy");
      if (name === "policy") {
        setPolicyImagesEager();
      }
    }
  }

  function setHomeFooterLabel(label) {
    const button = root.querySelector("#home__button-footer");
    if (!button) return;

    button.querySelectorAll(".menu__item-text, .menu__item-text-hvr").forEach((node) => {
      node.textContent = label;
    });
  }

  function isLightboxOpen() {
    return Boolean(root.querySelector("[data-product-lightbox].show"));
  }

  function closeCurrentLightbox() {
    const closeButton = root.querySelector("[data-product-lightbox].show [data-lightbox-close]");
    if (closeButton) {
      closeButton.click();
    }
    setHomeFooterLabel(footerBackHomeLabel);
  }

  function hideAllModals() {
    modals.forEach((modal) => {
      modal.hidden = true;
      modal.classList.remove("show");
      if (modal.id === "contact-modal" || modal.id === "mailinglist-modal") {
        modal.style.left = "";
        modal.style.top = "";
        modal.style.right = "";
        modal.style.bottom = "";
        modal.style.transform = "";
        modal.style.willChange = "";
        delete modal.dataset.mouseBaseLeft;
        delete modal.dataset.mouseBaseTop;
      }
    });
  }

  function showModal(id) {
    const modal = root.querySelector(`#${id}`);
    if (!modal) return;

    // Keep static modal placement deterministic on mobile by clearing any stale inline drag offsets.
    if (id === "contact-modal" || id === "mailinglist-modal") {
      modal.style.left = "";
      modal.style.top = "";
      modal.style.right = "";
      modal.style.bottom = "";
      modal.style.transform = "";
    }

    modal.hidden = false;
    modal.classList.add("show");

    if (id === "contact-modal" || id === "mailinglist-modal") {
      window.requestAnimationFrame(() => {
        const rect = modal.getBoundingClientRect();
        modal.dataset.mouseBaseLeft = String(rect.left);
        modal.dataset.mouseBaseTop = String(rect.top);
        modal.style.left = `${rect.left}px`;
        modal.style.top = `${rect.top}px`;
        modal.style.right = "auto";
        modal.style.bottom = "auto";
        modal.style.transform = "translate3d(0, 0, 0)";
        modal.style.willChange = "transform";
      });
    }
  }

  function initHomeModalMouseParallax() {
    const canHover = window.matchMedia("(hover: hover) and (pointer: fine)");
    if (!canHover.matches) return;

    let normX = 0.5;
    let normY = 0.5;
    let frame = 0;

    const update = () => {
      frame = 0;
      if (getCurrentViewName() !== "home") return;

      ["contact-modal", "mailinglist-modal"].forEach((id) => {
        const modal = root.querySelector(`#${id}`);
        if (!modal || modal.hidden || !modal.classList.contains("show")) return;

        const rect = modal.getBoundingClientRect();
        const baseLeft = Number(modal.dataset.mouseBaseLeft || rect.left);
        const baseTop = Number(modal.dataset.mouseBaseTop || rect.top);
        const requestedShiftX = (normX - 0.5) * rect.width * 0.3;
        const requestedShiftY = (normY - 0.5) * rect.height * 0.12;
        const minShiftX = -baseLeft;
        const maxShiftX = window.innerWidth - rect.width - baseLeft;
        const minShiftY = -baseTop;
        const maxShiftY = window.innerHeight - rect.height - baseTop;
        const shiftX = Math.max(minShiftX, Math.min(requestedShiftX, maxShiftX));
        const shiftY = Math.max(minShiftY, Math.min(requestedShiftY, maxShiftY));

        modal.style.transform = `translate3d(${shiftX}px, ${shiftY}px, 0)`;
      });
    };

    const queue = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    window.addEventListener("mousemove", (event) => {
      normX = window.innerWidth ? event.clientX / window.innerWidth : 0.5;
      normY = window.innerHeight ? event.clientY / window.innerHeight : 0.5;
      queue();
    });

    window.addEventListener("resize", () => {
      queue();
    });
  }

  function syncMobileProductThumbnails() {
    const isMobile = forceMobileDeviceLayout || window.matchMedia("(max-width: 1024px)").matches;

    productCards.forEach((card) => {
      const thumb = card.querySelector(".product-grid__mobile-thumbnail");
      const hoverImage = card.querySelector(".product-list__hover-image");
      if (!thumb || !hoverImage) return;

      if (!thumb.dataset.defaultSrc) {
        thumb.dataset.defaultSrc = thumb.getAttribute("src") || "";
        thumb.dataset.defaultSrcset = thumb.getAttribute("srcset") || "";
        thumb.dataset.defaultSizes = thumb.getAttribute("sizes") || "";
        thumb.dataset.defaultWidth = thumb.getAttribute("width") || "";
        thumb.dataset.defaultHeight = thumb.getAttribute("height") || "";
      }

      if (isMobile) {
        thumb.setAttribute("src", hoverImage.currentSrc || hoverImage.getAttribute("src") || thumb.dataset.defaultSrc);
        const hoverSrcset = hoverImage.getAttribute("srcset") || "";
        if (hoverSrcset) {
          thumb.setAttribute("srcset", hoverSrcset);
        } else {
          thumb.removeAttribute("srcset");
        }
        const hoverSizes = hoverImage.getAttribute("sizes") || "250px";
        thumb.setAttribute("sizes", hoverSizes);

        const hoverWidth = hoverImage.getAttribute("width") || "";
        const hoverHeight = hoverImage.getAttribute("height") || "";
        if (hoverWidth) thumb.setAttribute("width", hoverWidth);
        if (hoverHeight) thumb.setAttribute("height", hoverHeight);
        return;
      }

      if (thumb.dataset.defaultSrc) thumb.setAttribute("src", thumb.dataset.defaultSrc);
      if (thumb.dataset.defaultSrcset) {
        thumb.setAttribute("srcset", thumb.dataset.defaultSrcset);
      } else {
        thumb.removeAttribute("srcset");
      }
      if (thumb.dataset.defaultSizes) {
        thumb.setAttribute("sizes", thumb.dataset.defaultSizes);
      } else {
        thumb.removeAttribute("sizes");
      }
      if (thumb.dataset.defaultWidth) thumb.setAttribute("width", thumb.dataset.defaultWidth);
      if (thumb.dataset.defaultHeight) thumb.setAttribute("height", thumb.dataset.defaultHeight);
    });
  }

  function initDraggableModals() {
    Array.from(modals).forEach((modal) => {
      const modalId = modal.getAttribute("id") || "";
      if (modalId === "contact-modal" || modalId === "mailinglist-modal") {
        modal.style.cursor = "";
        return;
      }

      let activePointerId = null;
      let startX = 0;
      let startY = 0;
      let originLeft = 0;
      let originTop = 0;

      modal.style.cursor = "grab";

      const onPointerMove = (event) => {
        if (event.pointerId !== activePointerId) return;

        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;

        modal.style.left = `${originLeft + deltaX}px`;
        modal.style.top = `${originTop + deltaY}px`;
        modal.style.right = "auto";
        modal.style.bottom = "auto";
      };

      const endDrag = (event) => {
        if (activePointerId === null) return;
        if (event.pointerId !== activePointerId) return;

        activePointerId = null;
        modal.style.cursor = "grab";
        window.removeEventListener("pointermove", onPointerMove);
        window.removeEventListener("pointerup", endDrag);
        window.removeEventListener("pointercancel", endDrag);
      };

      modal.addEventListener("pointerdown", (event) => {
        if (event.button !== 0) return;
        if (event.target.closest("a, button, input, textarea, select, option, label")) return;

        activePointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;

        const rect = modal.getBoundingClientRect();
        originLeft = rect.left;
        originTop = rect.top;

        modal.style.left = `${originLeft}px`;
        modal.style.top = `${originTop}px`;
        modal.style.right = "auto";
        modal.style.bottom = "auto";
        modal.style.cursor = "grabbing";

        if (typeof modal.setPointerCapture === "function") {
          modal.setPointerCapture(activePointerId);
        }

        window.addEventListener("pointermove", onPointerMove);
        window.addEventListener("pointerup", endDrag);
        window.addEventListener("pointercancel", endDrag);
        event.preventDefault();
      });
    });
  }

  function closeProductDrawer() {
    if (!productPanel) return;
    closeAnySizeChart();
    productPanel.classList.remove("active");
    productPanel.setAttribute("aria-hidden", "true");
    hideProductDrawerLoader();
    setHomeFooterLabel(footerBackHomeLabel);
  }

  function closeAnySizeChart() {
    const modal = root.querySelector("#longmouth-product-drawer-content [data-size-chart-modal]");
    if (!modal) return;
    modal.classList.remove("show");
    modal.style.left = "";
    modal.style.top = "";
    modal.style.right = "";
    modal.style.bottom = "";
  }

  function closeOpenModules() {
    closeProductDrawer();
  }

  function getProductDrawerLoaderMarkup() {
    if (!productPanel) return "";
    const loaderUrl = productPanel.getAttribute("data-loader-url") || "";
    const loaderMedia = loaderUrl
      ? `<img src="${escapeHtml(loaderUrl)}" loading="eager" alt="Loading product" class="product-drawer-loader__image">`
      : '<div class="product-drawer-spinner" aria-hidden="true"></div>';

    return `
      <div class="product-drawer-loader" role="status" aria-live="polite" aria-label="Loading product details">
        ${loaderMedia}
      </div>
    `;
  }

  function showProductDrawerLoader() {
    if (!productPanel) return;
    const panelInner = productPanel.querySelector(".product__panel-inner");
    if (!panelInner) return;

    let loader = panelInner.querySelector(".product-drawer-loader");
    if (!loader) {
      panelInner.insertAdjacentHTML("beforeend", getProductDrawerLoaderMarkup());
      loader = panelInner.querySelector(".product-drawer-loader");
    }

    if (loader) {
      loader.hidden = false;
      loader.style.display = "flex";
    }
  }

  function hideProductDrawerLoader() {
    if (!productPanel) return;
    const loader = productPanel.querySelector(".product-drawer-loader");
    if (loader) {
      loader.hidden = true;
      loader.style.display = "none";
    }

    if (productDrawerContent) {
      productDrawerContent.hidden = false;
    }
  }

  function preloadImage(src) {
    return new Promise((resolve) => {
      const image = new Image();
      let settled = false;
      const done = () => {
        if (settled) return;
        settled = true;
        resolve();
      };
      image.onload = done;
      image.onerror = done;
      image.src = src;
      if (image.complete) done();
    });
  }

  async function preloadProductGalleryImages(product) {
    const imageSources = Array.from(new Set((product && product.images) || [])).filter(Boolean);
    if (!imageSources.length) return;
    await Promise.all(imageSources.map((source) => preloadImage(source)));
  }

  function waitForElementImageReady(image) {
    return new Promise((resolve) => {
      if (!image) {
        resolve();
        return;
      }

      const finalize = async () => {
        try {
          if (typeof image.decode === "function") {
            await image.decode();
          }
        } catch (error) {
          // Decoding failures should not block panel reveal.
        }
        resolve();
      };

      if (image.complete && image.naturalWidth > 0) {
        finalize();
        return;
      }

      image.addEventListener("load", finalize, { once: true });
      image.addEventListener("error", finalize, { once: true });
    });
  }

  async function waitForDrawerImagesReady() {
    if (!productDrawerContent) return;

    const drawerImages = Array.from(
      productDrawerContent.querySelectorAll(
        ".product-gallery-image, .product-lightbox-image, .product-gallery-thumb-image"
      )
    );

    if (!drawerImages.length) return;

    await Promise.all(drawerImages.map((image) => waitForElementImageReady(image)));

    // Ensure decoded images are ready for paint before revealing the panel content.
    await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  }

  function clampIndex(index, length) {
    if (!length) return 0;
    const normalized = Number(index) || 0;
    return ((normalized % length) + length) % length;
  }

  function escapeHtml(input) {
    return String(input || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function setCartCount(count) {
    Array.from(cartCountNodes).forEach((node) => {
      node.textContent = String(Number(count || 0));
    });
  }

  function setCartErrorVisible(isVisible) {
    if (!cartErrorNode) return;
    cartErrorNode.hidden = !isVisible;
  }

  function setCartLinePending(lineKey, pending) {
    if (!cartItemsContainer || !lineKey) return;

    const escapedLineKey = window.CSS && typeof window.CSS.escape === "function"
      ? window.CSS.escape(lineKey)
      : String(lineKey).replace(/"/g, '\\"');
    const row = cartItemsContainer.querySelector(`[data-line-key="${escapedLineKey}"]`);
    if (!row) return;

    row.classList.toggle("is-pending", pending);
    row.querySelectorAll("[data-cart-action]").forEach((actionButton) => {
      actionButton.disabled = pending;
    });
  }

  function setProductFormSubmitting(form, pending) {
    if (!form) return;

    const submitButton = form.querySelector('[data-waitlist-submit], button[type="submit"]');
    if (!submitButton) return;

    const defaultState = submitButton.querySelector(".button_default-state");
    const loadingState = submitButton.querySelector(".button_loading-state");

    submitButton.disabled = pending;
    submitButton.classList.toggle("is-loading", pending);
    if (defaultState) defaultState.classList.toggle("is-hidden", pending);
    if (loadingState) loadingState.classList.toggle("is-hidden", !pending);
  }

  function isCartOpen() {
    return Boolean(cartDropdownList && cartDropdownList.classList.contains("w--open"));
  }

  function openCart() {
    if (!cartDropdownList) return;
    cartDropdownList.classList.add("w--open");
    cartDropdownList.hidden = false;
    if (cartTrigger) cartTrigger.setAttribute("aria-expanded", "true");
  }

  function closeCart() {
    if (!cartDropdownList) return;
    cartDropdownList.classList.remove("w--open");
    cartDropdownList.hidden = true;
    if (cartTrigger) cartTrigger.setAttribute("aria-expanded", "false");
  }

  function toggleCart() {
    if (isCartOpen()) {
      closeCart();
      return;
    }
    openCart();
  }

  function getCartItemImage(item) {
    if (item && item.image) return item.image;
    return "";
  }

  function renderCartItems(cart) {
    if (!cartItemsContainer || !cartFormNode || !cartEmptyNode) return;

    const items = (cart && cart.items) || [];
    const hasItems = items.length > 0;

    cartFormNode.hidden = !hasItems;
    cartEmptyNode.hidden = hasItems;
    if (cartDropdownList) {
      cartDropdownList.classList.toggle("is-empty", !hasItems);
    }

    if (!hasItems) {
      cartItemsContainer.innerHTML = "";
      return;
    }

    const markup = items.map((item) => {
      const image = getCartItemImage(item);
      const options = (item.options_with_values || []).filter((opt) => opt && opt.value && opt.value !== "Default Title");
      const optionsMarkup = options
        .map((opt) => {
          return `<div class="display-inlineflex gap-tiny"><div option="name" class="mini-cart__text">${escapeHtml(opt.name)}</div><div class="mini-cart__text">:</div><div option="value" class="mini-cart__text">${escapeHtml(opt.value)}</div></div>`;
        })
        .join("");

      return `
        <div class="cart_item-wrapper" data-line-key="${escapeHtml(item.key)}">
          <div class="cart_image-wrapper">
            <button type="button" data-cart-action="remove" data-line-key="${escapeHtml(item.key)}" class="button is-remove" aria-label="Remove ${escapeHtml(item.product_title)} from cart">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="cart__close-button">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L12 10.9393L17.4697 5.46967C17.7626 5.17678 18.2374 5.17678 18.5303 5.46967C18.8232 5.76256 18.8232 6.23744 18.5303 6.53033L13.0607 12L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L12 13.0607L6.53033 18.5303C6.23744 18.8232 5.76256 18.8232 5.46967 18.5303C5.17678 18.2374 5.17678 17.7626 5.46967 17.4697L10.9393 12L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z" fill="currentColor"></path>
              </svg>
            </button>
            ${image ? `<img loading="lazy" alt="${escapeHtml(item.product_title)}" src="${escapeHtml(image)}" class="cart_item-image">` : ""}
          </div>
          <div class="mini-cart_item-data">
            <div class="mini-cart__text">${escapeHtml(item.product_title)}</div>
            ${optionsMarkup}
            <div class="display-flex space-between full-width">
              <div class="mini-cart_quantity-wrapper">
                <div>${item.quantity}</div>
                <div>x</div>
                <div>${escapeHtml(formatMoney(item.final_price))}</div>
              </div>
              <div class="add-to-cart_quantity-input-2">
                <button type="button" data-cart-action="minus" data-line-key="${escapeHtml(item.key)}" data-quantity="${item.quantity}" class="add-to-cart_quantity-button" aria-label="Decrease quantity">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="" class="svg-icon-qt-2"><path d="M0 0h24v24H0z" fill="transparent"></path><path d="M19 13H5v-2h14v2z" fill="currentColor"></path></svg>
                </button>
                <input class="atc__quantity-field cart w-input" type="number" value="${item.quantity}" readonly aria-label="Quantity for ${escapeHtml(item.product_title)}">
                <button type="button" data-cart-action="plus" data-line-key="${escapeHtml(item.key)}" data-quantity="${item.quantity}" class="add-to-cart_quantity-button" aria-label="Increase quantity">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="svg-icon-qt-2"><path d="M0 0h24v24H0z" fill="transparent"></path><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="currentColor"></path></svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      `;
    }).join("");

    cartItemsContainer.innerHTML = markup;
  }

  async function fetchCartData() {
    const response = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!response.ok) throw new Error("Unable to fetch cart");
    return response.json();
  }

  async function refreshCartUI(options = {}) {
    const shouldOpen = Boolean(options.open);

    try {
      const cart = await fetchCartData();
      setCartCount(cart.item_count || 0);
      if (cartTotalNode) cartTotalNode.textContent = formatMoney(cart.total_price || 0);
      renderCartItems(cart);
      setCartErrorVisible(false);

      if (shouldOpen && cart.item_count > 0) {
        openCart();
      }
    } catch (error) {
      console.error("Failed to refresh cart", error);
      setCartErrorVisible(true);
    }
  }

  async function updateCartLine(lineKey, quantity) {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: lineKey, quantity }),
    });

    if (!response.ok) throw new Error("Unable to update cart line");
    return response.json();
  }

  function initCart() {
    if (!cartTrigger || !cartDropdownList || !cartWrapper) return;

    cartTrigger.addEventListener("click", function (event) {
      event.preventDefault();
      const opening = !isCartOpen();
      toggleCart();
      if (opening) {
        refreshCartUI();
      }
    });

    if (cartContinueNode) {
      cartContinueNode.addEventListener("click", function () {
        closeCart();
      });

      cartContinueNode.addEventListener("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        closeCart();
      });
    }

    document.addEventListener("click", function (event) {
      if (!isCartOpen()) return;
      if (cartWrapper.contains(event.target)) return;
      closeCart();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      if (isLightboxOpen()) {
        closeCurrentLightbox();
        event.preventDefault();
        return;
      }
      closeCart();
    });

    if (cartItemsContainer) {
      cartItemsContainer.addEventListener("click", async function (event) {
        const button = event.target.closest("[data-cart-action]");
        if (!button) return;

        const action = button.getAttribute("data-cart-action");
        const lineKey = button.getAttribute("data-line-key");
        const row = button.closest(".cart_item-wrapper");
        const buttonQuantity = Number(button.getAttribute("data-quantity") || 0);
        const fieldQuantity = Number(row?.querySelector(".atc__quantity-field")?.value || 0);
        const currentQuantity = buttonQuantity || fieldQuantity || 0;
        if (!lineKey) return;
        if (pendingCartLineKeys.has(lineKey)) return;

        let nextQuantity = currentQuantity;
        if (action === "remove") nextQuantity = 0;
        if (action === "plus") nextQuantity = Math.max(1, currentQuantity + 1);
        if (action === "minus") nextQuantity = Math.max(0, currentQuantity - 1);

        pendingCartLineKeys.add(lineKey);
        setCartLinePending(lineKey, true);

        try {
          await updateCartLine(lineKey, nextQuantity);
          await refreshCartUI({ open: true });
        } catch (error) {
          console.error("Failed to update cart", error);
          setCartErrorVisible(true);
        } finally {
          pendingCartLineKeys.delete(lineKey);
          setCartLinePending(lineKey, false);
        }
      });
    }

    refreshCartUI();
  }

  function getSelectedOptions(product, optionState) {
    return (product.options || []).map((name, index) => {
      const indexedKey = `__option${index + 1}`;
      return optionState[indexedKey]
        || optionState[name]
        || (product.variants[0] && product.variants[0][`option${index + 1}`])
        || "";
    });
  }

  function findVariant(product, optionState) {
    const selected = getSelectedOptions(product, optionState);
    return product.variants.find((variant) => {
      return selected.every((value, index) => variant[`option${index + 1}`] === value);
    }) || null;
  }

  function getVariantQuantityRule(variant) {
    const source = variant && (variant.quantity_rule || variant.quantity_rules || {});
    const min = Math.max(1, Number(source.min) || 1);
    const maxRaw = Number(source.max);
    const max = Number.isFinite(maxRaw) && maxRaw > 0 ? maxRaw : null;
    const increment = Math.max(1, Number(source.increment) || 1);
    return { min, max, increment };
  }

  function isVariantPurchasableAtMinimum(variant, minimumQuantity) {
    if (!variant || !variant.available) return false;

    const managedInventory = String(variant.inventory_management || "").trim() !== "";
    const canContinueSelling = String(variant.inventory_policy || "").toLowerCase() === "continue";

    if (!managedInventory || canContinueSelling) {
      return true;
    }

    const inventoryQuantity = Number(variant.inventory_quantity);
    if (!Number.isFinite(inventoryQuantity)) {
      return true;
    }

    return inventoryQuantity >= minimumQuantity;
  }

  function renderVariantControls(product, optionState) {
    if (!product.options || !product.options.length) return "";

    return product.options
      .map((option, optionIndex) => {
        const optionName = typeof option === "string" ? option : (option?.name || String(option));
        const key = `option${optionIndex + 1}`;
        const values = Array.from(new Set(product.variants.map((v) => v[key]).filter(Boolean)));

        // Skip the Shopify default single-variant placeholder
        if (values.length === 1 && values[0] === "Default Title") return "";

        const selected = optionState[optionName] || values[0] || "";

        const unavailableValues = new Set(
          values.filter((value) => {
            return !product.variants.some((variant) => {
              if (variant[key] !== value || !variant.available) return false;

              return (product.options || []).every((otherOptionName, otherIndex) => {
                if (otherIndex === optionIndex) return true;
                const otherKey = `option${otherIndex + 1}`;
                const selectedOther = optionState[`__option${otherIndex + 1}`]
                  || optionState[otherOptionName]
                  || (product.variants[0] && product.variants[0][otherKey])
                  || "";
                return !selectedOther || variant[otherKey] === selectedOther;
              });
            });
          })
        );

        const buttons = values
          .map((value) => {
            const activeClass = selected === value ? " active" : "";
            const disabledClass = unavailableValues.has(value) ? " is-disabled" : "";
            return `<button type="button" class="variant_option-button${activeClass}${disabledClass}" data-option-value="${escapeHtml(value)}"><div class="variant_option-label" data-swatch-label="${escapeHtml(value)}"><span class="variant_option-label-text">${escapeHtml(value)}</span></div></button>`;
          })
          .join("");

        return `<div class="variant-swatches" data-option-name="${escapeHtml(optionName)}" data-option-index="${optionIndex}"><label class="variant-label is-hidden">${escapeHtml(optionName)}</label><div class="variant__options">${buttons}</div></div>`;
      })
      .join("");
  }

  function renderGalleryMarkup(product, optionState, closeIconUrl) {
    const images = product.images || [];
    const hasImages = images.length > 0;
    const activeIndex = clampIndex(optionState.__galleryIndex, images.length);
    optionState.__galleryIndex = activeIndex;

    if (!hasImages) {
      return `
        <div class="product-gallery-shell product-gallery-shell--empty">
          <div class="product-gallery-stage product-gallery-stage--empty">No product images available.</div>
        </div>
      `;
    }

    const slides = images
      .map((src, index) => {
        return `
          <li class="splide__slide product-gallery-slide" data-gallery-index="${index}">
            <button type="button" class="product-gallery-open" data-gallery-open="${index}" aria-label="Open image ${index + 1} of ${images.length}">
              <img class="product-gallery-image" loading="eager" src="${escapeHtml(src)}" alt="${escapeHtml(product.title)} image ${index + 1}">
            </button>
          </li>
        `;
      })
      .join("");

    const dots = images
      .map((_, index) => {
        const isActive = index === activeIndex ? " is-active" : "";
        return `<button type="button" class="product-gallery-dot${isActive}" data-gallery-thumb="${index}" aria-label="Show image ${index + 1}"></button>`;
      })
      .join("");

    const lightboxSlides = images
      .map((src, index) => {
        return `
          <li class="splide__slide product-lightbox-slide" data-lightbox-slide="${index}">
            <img class="product-lightbox-image" loading="eager" src="${escapeHtml(src)}" alt="${escapeHtml(product.title)} detail ${index + 1}">
          </li>
        `;
      })
      .join("");

    const lightboxThumbs = images
      .map((src, index) => {
        const isActive = index === activeIndex ? " is-active" : "";
        return `
          <button type="button" class="sm-image-gallery_thumbnail-image product-lightbox-thumb${isActive}" data-lightbox-thumb="${index}" aria-label="View detail image ${index + 1}">
            <img class="product-gallery-thumb-image" loading="eager" src="${escapeHtml(src)}" alt="${escapeHtml(product.title)} detail thumbnail ${index + 1}">
          </button>
        `;
      })
      .join("");

    const openClass = optionState.__lightboxOpen ? " show" : "";

    return `
      <div class="product-gallery-shell" data-gallery-length="${images.length}">
        <div class="product-gallery-stage splide" data-gallery-splide>
          <button type="button" class="product-gallery-arrow product-gallery-arrow--prev" data-gallery-prev aria-label="Previous image">&#8249;</button>
          <div class="splide__track product-gallery-viewport">
            <ul class="splide__list">${slides}</ul>
          </div>
          <button type="button" class="product-gallery-arrow product-gallery-arrow--next" data-gallery-next aria-label="Next image">&#8250;</button>
        </div>
        <div class="product-gallery-dots">${dots}</div>
        <div class="sm-image-gallery_container product${openClass}" data-product-lightbox>
          <button type="button" class="close-btn__wrapper" data-lightbox-close aria-label="Close gallery">
            <img src="${escapeHtml(closeIconUrl)}" loading="eager" alt="close" class="close-btn__x">
          </button>
          <div class="product-lightbox-stage splide" data-lightbox-splide>
            <button type="button" class="sm-slider_arrow product-lightbox-arrow" data-lightbox-prev aria-label="Previous gallery image">&#8249;</button>
            <div class="splide__track product-lightbox-viewport">
              <ul class="splide__list">${lightboxSlides}</ul>
            </div>
            <button type="button" class="sm-slider_arrow product-lightbox-arrow" data-lightbox-next aria-label="Next gallery image">&#8250;</button>
          </div>
          <div class="sm-image-gallery_thumbnails">${lightboxThumbs}</div>
        </div>
      </div>
    `;
  }

  function renderProductDrawer(product, optionState) {
    if (!productDrawerContent) return;

    const selectedVariant = findVariant(product, optionState);
    const quantityRule = getVariantQuantityRule(selectedVariant);
    const minimumQuantity = quantityRule.min;
    const isSoldOut = !isVariantPurchasableAtMinimum(selectedVariant, minimumQuantity);
    const closeIconUrl = productPanel ? (productPanel.getAttribute('data-close-icon-url') || '') : '';
    const gallery = renderGalleryMarkup(product, optionState, closeIconUrl);
    let quantity = Number(optionState.__quantity || minimumQuantity);
    if (!Number.isFinite(quantity)) quantity = minimumQuantity;
    quantity = Math.max(minimumQuantity, quantity);
    if (quantityRule.max !== null) {
      quantity = Math.min(quantity, quantityRule.max);
    }
    const offsetFromMin = quantity - minimumQuantity;
    if (offsetFromMin % quantityRule.increment !== 0) {
      quantity = minimumQuantity + (Math.floor(offsetFromMin / quantityRule.increment) * quantityRule.increment);
      if (quantity < minimumQuantity) quantity = minimumQuantity;
    }
    optionState.__quantity = quantity;
    const isAtMinimumQuantity = quantity <= minimumQuantity;
    const minusDisabled = isSoldOut || isAtMinimumQuantity;
    const minusInlineStyle = isAtMinimumQuantity ? ' style="opacity: 0.2;"' : "";
    const priceMarkup = !isSoldOut
      ? `
        <div class="product__price-wrap">
          ${selectedVariant.compare_at_price > selectedVariant.price
            ? `<span class="price_compare-at-price-3">${formatMoney(selectedVariant.compare_at_price)}</span>`
            : ""}
          <span class="price_regular-price-3">${formatMoney(selectedVariant.price)}</span>
        </div>
      `
      : `
        <div class="product__sold-out-wrap">
          <span class="price_regular-price-3">sold out</span>
        </div>
      `;
    const submitLabel = !isSoldOut ? "add to cart" : "get notified";
    const submitType = !isSoldOut ? "submit" : "button";
    const notifyToggleAttr = !isSoldOut ? "" : " data-product-notify-toggle";
    const sizeOptionIndex = (product.options || []).findIndex((optionName) => /size/i.test(String(optionName || "")));
    const selectedSizeValue = sizeOptionIndex > -1
      ? (optionState[`__option${sizeOptionIndex + 1}`]
          || optionState[product.options[sizeOptionIndex]]
          || (selectedVariant ? selectedVariant[`option${sizeOptionIndex + 1}`] : "")
          || "")
      : "";
    const notifyTags = `notify_me,notify_product_${String(product.handle || "").replace(/[^a-z0-9_-]/gi, "_").toLowerCase()}`;
    const buttonLoaderUrl = productPanel ? (productPanel.getAttribute("data-loader-url") || "") : "";
    const buttonLoaderMarkup = buttonLoaderUrl
      ? `<img src="${escapeHtml(buttonLoaderUrl)}" loading="eager" alt="" class="button_loading-spinner" aria-hidden="true">`
      : '<span class="button_loading-spinner button_loading-spinner--fallback" aria-hidden="true"></span>';
    const sizeChartUrl = optionState.__sizeChartUrl || "";
    const sizeChartMarkup = sizeChartUrl
      ? `<div class="product__size-chart-link" data-size-chart-toggle>size chart</div>
         <div class="modal__size-chart product__modal" data-size-chart-modal>
           <img src="${escapeHtml(closeIconUrl)}" class="close" alt="close" data-size-chart-close>
           <img src="${escapeHtml(sizeChartUrl)}" class="size-chart__svg" alt="size chart">
         </div>`
      : "";
    const sizeChartData = optionState.__sizeChartData || null;
    const resolvedSizeChartMarkup = sizeChartData
      ? renderSizeChartTable(sizeChartData, closeIconUrl)
      : sizeChartUrl
        ? `<div class="product__size-chart-link" data-size-chart-toggle>size chart</div>
           <div class="modal__size-chart product__modal" data-size-chart-modal>
             <img src="${escapeHtml(closeIconUrl)}" class="close" alt="close" data-size-chart-close>
             <img src="${escapeHtml(sizeChartUrl)}" class="size-chart__svg" alt="size chart">
           </div>`
        : "";
      const selectedVariantLabel = selectedVariant && selectedVariant.title ? String(selectedVariant.title) : "";
      const notifySizeText = selectedSizeValue ? ` | Size: ${escapeHtml(String(selectedSizeValue))}` : "";
      const waitlistSuccessNode = root.querySelector("#mailinglist-modal [data-waitlist-success]");
      const sharedSuccessText = waitlistSuccessNode && waitlistSuccessNode.textContent
        ? waitlistSuccessNode.textContent.trim()
        : "Please check your email for confirmation";
      const minimumOrderCopy = minimumQuantity > 1
        ? `<p class="goth-text black" data-product-minimum-note style="position: absolute; bottom: 0; display: flex; justify-content: space-evenly; width: 100%; color: #9f9f9f;">minimum order: ${minimumQuantity}</p>`
        : "";
      const notifyModalMarkup = `
        <div class="modal-waitlist product__modal" data-product-notify-modal hidden>
          <button type="button" class="close-btn__wrapper" data-product-notify-close aria-label="Close get notified modal">
            <img src="${escapeHtml(closeIconUrl)}" loading="eager" alt="close" class="close-btn__x">
          </button>
          <h1 class="default">get notified</h1>
          <form class="form" data-product-notify-form>
            <input type="hidden" name="form_type" value="customer">
            <input type="hidden" name="utf8" value="✓">
            <input type="hidden" name="contact[tags]" value="${escapeHtml(notifyTags)}">
            <input type="hidden" name="contact[body]" value="Notify me when available: ${escapeHtml(String(product.title || ""))} (${escapeHtml(String(product.handle || ""))})${selectedVariantLabel ? ` - ${escapeHtml(selectedVariantLabel)}` : ""}${notifySizeText}">
            <input type="hidden" name="contact[product_title]" value="${escapeHtml(String(product.title || ""))}">
            <input type="hidden" name="contact[product_handle]" value="${escapeHtml(String(product.handle || ""))}">
            <input type="hidden" name="contact[variant_title]" value="${escapeHtml(selectedVariantLabel)}">
            <input type="hidden" name="contact[selected_size]" value="${escapeHtml(String(selectedSizeValue || ""))}">
            <input type="hidden" name="contact[product_id]" value="${escapeHtml(String(product.id || ""))}">
            <input type="hidden" name="contact[variant_id]" value="${escapeHtml(String(selectedVariant ? selectedVariant.id : ""))}">
            <label for="NotifyEmail-${escapeHtml(String(product.id))}" class="field-label">email address</label>
            <input id="NotifyEmail-${escapeHtml(String(product.id))}" type="email" name="contact[email]" required class="text-field-2 w-input" placeholder="yawgmoth@email.com">
            <button type="submit" class="button w-button signup-submit">
              <div class="button_default-state"><span class="atc__btn-text">submit</span></div>
              <div class="button_loading-state is-hidden" aria-hidden="true">
                ${buttonLoaderMarkup}
                <span class="atc__btn-text">wait...</span>
              </div>
            </button>
            <p class="goth-text black" data-product-notify-success hidden>${escapeHtml(sharedSuccessText)}</p>
            <p class="goth-text black" data-product-notify-error hidden>unable to submit right now.</p>
          </form>
        </div>
      `;

    productDrawerContent.innerHTML = `
      <div class="product-content-wrapper" data-product-handle="${escapeHtml(product.handle)}">
        <div class="product">
          <div class="product__gallery">${gallery}</div>
          <div class="product__content">
            <div class="product-details">
              <div class="product-details__title">${escapeHtml(product.title)}</div>
              ${priceMarkup}
              ${resolvedSizeChartMarkup}
              <div class="spacer__vertical40 mobile--hide"></div>
              <div class="product-detail__wrap">
                <div class="product-details__description">${product.description || ""}</div>
              </div>
            </div>
            <div class="product-options">
              <form id="drawer-product-form" class="form product-drawer-form" data-product-id="${product.id}">
                ${renderVariantControls(product, optionState)}
                <input type="hidden" name="id" value="${selectedVariant ? selectedVariant.id : ""}">
                <div class="atc_wrapper">
                  <div class="quantity-input${isSoldOut ? " is-sold-out" : ""}">
                    <div class="add-to-cart_quantity-input">
                      <button type="button" class="add-to-cart_quantity-button left${minusDisabled ? " is-disabled" : ""}" data-quantity-change="-1" aria-label="Decrease quantity"${minusDisabled ? " disabled aria-disabled=\"true\" tabindex=\"-1\"" : ""}${minusInlineStyle}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="product-slider_lightbox-icon"><path d="M0 0h24v24H0z" fill="none"></path><path d="M19 13H5v-2h14v2z" fill="currentColor"></path></svg>
                      </button>
                      <input class="atc__quantity-field add-to-cart-2" type="number" value="${quantity}" readonly aria-label="Quantity">
                      <button type="button" class="add-to-cart_quantity-button right" data-quantity-change="1" aria-label="Increase quantity"${isSoldOut ? " disabled aria-disabled=\"true\" tabindex=\"-1\"" : ""}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="product-slider_lightbox-icon"><path d="M0 0h24v24H0z" fill="none"></path><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="currentColor"></path></svg>
                      </button>
                      ${minimumOrderCopy}
                    </div>
                  </div>
                  <p class="goth-text black" data-product-cart-error hidden></p>
                  <button type="${submitType}" class="button is-icon product-drawer-submit"${notifyToggleAttr}>
                    <div class="button_default-state"><span class="atc__btn-text">${submitLabel}</span></div>
                    <div class="button_loading-state is-hidden" aria-hidden="true">
                      ${buttonLoaderMarkup}
                      <span class="atc__btn-text">wait...</span>
                    </div>
                  </button>
                </div>
              </form>
            </div>
          </div>
          ${notifyModalMarkup}
        </div>
      </div>
    `;

    bindDrawerForm(product, optionState);
    bindDrawerGallery(product, optionState);
    bindSizeChart(productDrawerContent);
    bindMobileDescriptionPause(productDrawerContent);
    bindProductNotify(productDrawerContent);
  }

  function bindProductNotify(contentRoot) {
    if (!contentRoot) return;
    const modal = contentRoot.querySelector("[data-product-notify-modal]");
    if (!modal) return;

    const form = modal.querySelector("[data-product-notify-form]");
    const closeBtn = modal.querySelector("[data-product-notify-close]");
    const success = modal.querySelector("[data-product-notify-success]");
    const error = modal.querySelector("[data-product-notify-error]");
    const emailInput = form ? form.querySelector('input[name="contact[email]"]') : null;
    const defaultErrorText = error ? error.textContent : "we couldn't submit your email right now. please try again.";

    const getInputValue = (name) => {
      if (!form) return "";
      const field = form.querySelector(`[name="${name}"]`);
      return String(field?.value || "").trim();
    };

    const getProductNotifyMetadata = () => {
      return {
        source: "product_notify",
        notify_tags: getInputValue("contact[tags]"),
        notify_message: getInputValue("contact[body]"),
        product_title: getInputValue("contact[product_title]"),
        product_handle: getInputValue("contact[product_handle]"),
        variant_title: getInputValue("contact[variant_title]"),
        selected_size: getInputValue("contact[selected_size]"),
        product_id: getInputValue("contact[product_id]"),
        variant_id: getInputValue("contact[variant_id]"),
      };
    };

    scheduleSignupFieldsRestore(form, success, error, defaultErrorText);
    startSignupCooldownTicker(form, error, defaultErrorText);

    const resetProductNotifyStatus = () => {
      if (!form) return;
      if (form.dataset.signupCompleted === "true") {
        if (getWaitlistCooldownRemainingMs() <= 0) {
          restoreSignupFields(form, success, error, defaultErrorText);
          startSignupCooldownTicker(form, error, defaultErrorText);
          return;
        }
        if (success) success.hidden = false;
        if (error) error.hidden = true;
        return;
      }
      if (success) success.hidden = true;
      if (error) {
        error.hidden = true;
        error.textContent = defaultErrorText;
      }

      startSignupCooldownTicker(form, error, defaultErrorText);
    };

    const centerInPanel = () => {
      const panel = root.querySelector(".product__panel-inner");
      if (!panel) return;
      const panelRect = panel.getBoundingClientRect();
      const modalRect = modal.getBoundingClientRect();
      const left = panelRect.left + ((panelRect.width - modalRect.width) / 2);
      const top = panelRect.top + ((panelRect.height - modalRect.height) / 2);
      const maxLeft = Math.max(0, window.innerWidth - modalRect.width);
      const maxTop = Math.max(0, window.innerHeight - modalRect.height);
      const clampedLeft = Math.max(0, Math.min(left, maxLeft));
      const clampedTop = Math.max(0, Math.min(top, maxTop));

      modal.style.left = `${clampedLeft}px`;
      modal.style.top = `${clampedTop}px`;
      modal.style.right = "auto";
      modal.style.bottom = "auto";
      modal.style.transform = "none";
    };

    const openModal = () => {
      modal.hidden = false;
      modal.classList.add("show");
      resetProductNotifyStatus();
      window.requestAnimationFrame(centerInPanel);
    };

    const closeModal = () => {
      modal.classList.remove("show");
      modal.hidden = true;
      modal.style.left = "";
      modal.style.top = "";
      modal.style.right = "";
      modal.style.bottom = "";
      modal.style.transform = "";
      clearSignupCooldownTicker(form);
    };

    contentRoot.querySelectorAll("[data-product-notify-toggle]").forEach((button) => {
      button.addEventListener("click", openModal);
    });

    closeBtn?.addEventListener("click", closeModal);

    window.addEventListener("resize", () => {
      if (!modal.classList.contains("show")) return;
      centerInPanel();
    });

    form?.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (form.dataset.signupCompleted === "true") {
        if (getWaitlistCooldownRemainingMs() > 0) return;
        restoreSignupFields(form, success, error, defaultErrorText);
      }
      resetProductNotifyStatus();

      setProductFormSubmitting(form, true);

      try {
        const email = String(emailInput?.value || "").trim();
        if (!email) throw new Error("notify_email_missing");

        const cooldownRemaining = getWaitlistCooldownRemainingMs();
        if (cooldownRemaining > 0) {
          if (error) {
            error.textContent = formatCooldownMessage(cooldownRemaining);
            error.hidden = false;
          }
          startSignupCooldownTicker(form, error, defaultErrorText);
          return;
        }

        await submitWaitlistViaKlaviyo(email);
        trackKlaviyoEventByEmail(
          email,
          "Product Notify Requested",
          {
            ...getProductNotifyMetadata(),
            requested_at_iso: new Date().toISOString(),
          }
        ).catch((eventError) => {
          // Event tracking failures should not block user signup success.
          console.error("Product notify event tracking failed", eventError);
        });
        setWaitlistCooldownNow();
        replaceSignupFieldsWithSuccess(form, success);
        scheduleSignupFieldsRestore(form, success, error, defaultErrorText);
        startSignupCooldownTicker(form, error, defaultErrorText);
        form.reset();
      } catch (e) {
        console.error("Product notify submit failed", e);
        if (error) {
          error.textContent = getSignupErrorMessage(e, defaultErrorText);
          error.hidden = false;
        }
      } finally {
        setProductFormSubmitting(form, false);
      }
    });
  }

  function bindMobileDescriptionPause(contentRoot) {
    if (!contentRoot) return;

    const details = contentRoot.querySelector(".product-details");
    const wrap = contentRoot.querySelector(".product-detail__wrap");
    const description = contentRoot.querySelector(".product-details__description");
    if (!description) return;

    description.classList.remove("marquee-paused");
    if (!(forceMobileDeviceLayout || window.matchMedia("(max-width: 1024px)").matches)) return;

    if (!description.dataset.marqueePrepared) {
      const sourceMarkup = description.innerHTML;
      description.innerHTML = `<span class="product-description__segment">${sourceMarkup}</span><span class="product-description__segment" aria-hidden="true">${sourceMarkup}</span>`;
      description.dataset.marqueePrepared = "true";
    }
    description.classList.add("is-loop-ready");

    const target = details || wrap || description;
    let isPaused = false;

    const pause = () => {
      if (isPaused) return;
      isPaused = true;
      description.classList.add("marquee-paused");
    };

    const resume = () => {
      if (!isPaused) return;
      isPaused = false;
      description.classList.remove("marquee-paused");
    };

    target.addEventListener("pointerdown", (event) => {
      if (event.pointerType === "mouse") return;
      pause();
    });
    target.addEventListener("pointerup", resume);
    target.addEventListener("pointercancel", resume);
    target.addEventListener("pointerleave", resume);

    target.addEventListener("touchstart", pause, { passive: true });
    target.addEventListener("touchend", resume, { passive: true });
    target.addEventListener("touchcancel", resume, { passive: true });
  }

  function bindSizeChart(contentRoot) {
    const link = contentRoot.querySelector("[data-size-chart-toggle]");
    const modal = contentRoot.querySelector("[data-size-chart-modal]");
    const closeBtn = contentRoot.querySelector("[data-size-chart-close]");
    if (!link || !modal) return;

    const centerModalInPanel = () => {
      const panel = root.querySelector(".product__panel-inner");
      if (!panel) return;
      const panelRect = panel.getBoundingClientRect();
      const modalRect = modal.getBoundingClientRect();
      const left = panelRect.left + ((panelRect.width - modalRect.width) / 2);
      const top = panelRect.top + ((panelRect.height - modalRect.height) / 2);
      const maxLeft = Math.max(0, window.innerWidth - modalRect.width);
      const maxTop = Math.max(0, window.innerHeight - modalRect.height);
      const clampedLeft = Math.max(0, Math.min(left, maxLeft));
      const clampedTop = Math.max(0, Math.min(top, maxTop));
      modal.style.left = `${clampedLeft}px`;
      modal.style.top = `${clampedTop}px`;
      modal.style.right = "auto";
      modal.style.bottom = "auto";
    };

    const closeModal = () => {
      modal.classList.remove("show");
    };

    link.addEventListener("click", () => {
      const willShow = !modal.classList.contains("show");
      modal.classList.toggle("show", willShow);
      if (!willShow) return;
      window.requestAnimationFrame(centerModalInPanel);
    });
    if (closeBtn) {
      closeBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        closeModal();
      });
    }

    window.addEventListener("resize", () => {
      if (!modal.classList.contains("show")) return;
      centerModalInPanel();
    });

    const container = modal.querySelector(".size-chart__container");
    if (!container) return;

    modal.querySelectorAll(".size-chart__unit-btn").forEach((btn) => {
      btn.addEventListener("click", function () {
        const unit = this.getAttribute("data-unit");
        container.setAttribute("data-active-unit", unit);
        modal.querySelectorAll(".size-chart__unit-btn").forEach((b) => {
          b.classList.toggle("is-active", b === this);
        });
        modal.querySelectorAll(".size-chart__cell").forEach((cell) => {
          cell.textContent = cell.getAttribute(`data-${unit}`) ?? "";
        });
      });
    });
  }

  function renderSizeChartTable(chartData, closeIconUrl) {
    const sizes = Array.isArray(chartData.sizes) ? chartData.sizes : [];
    const rows = Array.isArray(chartData.rows) ? chartData.rows : [];
    const unit = chartData.unit || "in";

    const headerCells = sizes
      .map((s) => `<th class="size-chart__size-header">${escapeHtml(String(s))}</th>`)
      .join("");

    const bodyRows = rows.map((row) => {
      const cells = sizes.map((_, i) => {
        const inVal = Array.isArray(row.in) ? (row.in[i] ?? "") : "";
        const cmVal = Array.isArray(row.cm) ? (row.cm[i] ?? "") : "";
        const displayVal = unit === "cm" ? cmVal : inVal;
        return `<td class="size-chart__cell" data-in="${escapeHtml(String(inVal))}" data-cm="${escapeHtml(String(cmVal))}">${escapeHtml(String(displayVal))}</td>`;
      }).join("");
      const labelParts = (row.label || "").split(" ");
      const labelHtml = labelParts.length > 1
        ? `${escapeHtml(labelParts[0])}<br>${escapeHtml(labelParts.slice(1).join(" "))}`
        : escapeHtml(row.label || "");
      return `<tr><td class="size-chart__row-label">${labelHtml}</td>${cells}</tr>`;
    }).join("");

    return `
      <div class="product__size-chart-link" data-size-chart-toggle>size chart</div>
      <div class="modal__size-chart product__modal" data-size-chart-modal>
        <img src="${escapeHtml(closeIconUrl)}" class="close" alt="close" data-size-chart-close>
        <div class="size-chart__container" data-active-unit="${escapeHtml(unit)}">
          <table class="size-chart__table">
            <thead>
              <tr>
                <th class="size-chart__corner-cell">
                  <div class="size-chart__unit-toggle">
                    <button type="button" class="size-chart__unit-btn${unit === "in" ? " is-active" : ""}" data-unit="in">in</button>
                    <button type="button" class="size-chart__unit-btn${unit === "cm" ? " is-active" : ""}" data-unit="cm">cm</button>
                  </div>
                </th>
                ${headerCells}
              </tr>
            </thead>
            <tbody>${bodyRows}</tbody>
          </table>
        </div>
      </div>
    `;
  }

  function bindDrawerGallery(product, optionState) {
    const contentRoot = root.querySelector("#longmouth-product-drawer-content");
    if (!contentRoot) return;

    if (contentRoot.__galleryAbortController) {
      contentRoot.__galleryAbortController.abort();
    }
    const galleryAbortController = new AbortController();
    const gallerySignal = galleryAbortController.signal;
    contentRoot.__galleryAbortController = galleryAbortController;

    const images = product.images || [];
    if (!images.length) return;

    const SplideCtor = window.Splide;
    if (typeof SplideCtor !== "function") return;

    const mainRoot = contentRoot.querySelector("[data-gallery-splide]");
    const lightboxRoot = contentRoot.querySelector("[data-lightbox-splide]");
    const lightboxWrap = contentRoot.querySelector("[data-product-lightbox]");
    if (!mainRoot) return;

    if (mainRoot.__lmSplideInstance) {
      mainRoot.__lmSplideInstance.destroy();
      mainRoot.__lmSplideInstance = null;
    }

    const startIndex = clampIndex(optionState.__galleryIndex || 0, images.length);
    const splideOptions = {
      type: "loop",
      direction: "ltr",
      perPage: 1,
      perMove: 1,
      start: startIndex,
      drag: true,
      waitForTransition: true,
      arrows: false,
      pagination: false,
      speed: 784,
    };

    const mainSplide = new SplideCtor(mainRoot, splideOptions);
    mainRoot.__lmSplideInstance = mainSplide;
    let lightboxSplide = null;
    let mainMoveLocked = false;
    let lightboxMoveLocked = false;
    let mainUnlockTimer = 0;
    let lightboxUnlockTimer = 0;

    const clearMainUnlockTimer = () => {
      if (!mainUnlockTimer) return;
      window.clearTimeout(mainUnlockTimer);
      mainUnlockTimer = 0;
    };

    const clearLightboxUnlockTimer = () => {
      if (!lightboxUnlockTimer) return;
      window.clearTimeout(lightboxUnlockTimer);
      lightboxUnlockTimer = 0;
    };

    const lockMainMove = () => {
      mainMoveLocked = true;
      clearMainUnlockTimer();
      mainUnlockTimer = window.setTimeout(() => {
        mainMoveLocked = false;
        mainUnlockTimer = 0;
      }, splideOptions.speed + 140);
    };

    const unlockMainMove = () => {
      mainMoveLocked = false;
      clearMainUnlockTimer();
    };

    const lockLightboxMove = () => {
      lightboxMoveLocked = true;
      clearLightboxUnlockTimer();
      lightboxUnlockTimer = window.setTimeout(() => {
        lightboxMoveLocked = false;
        lightboxUnlockTimer = 0;
      }, splideOptions.speed + 140);
    };

    const unlockLightboxMove = () => {
      lightboxMoveLocked = false;
      clearLightboxUnlockTimer();
    };

    const goMainStep = (step) => {
      if (mainMoveLocked) return;
      const target = clampIndex(mainSplide.index + (step > 0 ? 1 : -1), images.length);
      applyActiveState(target);
      lockMainMove();
      mainSplide.go(step > 0 ? "+1" : "-1");
    };

    const goLightboxStep = (step) => {
      if (!lightboxSplide || lightboxMoveLocked) return;
      const target = clampIndex(lightboxSplide.index + (step > 0 ? 1 : -1), images.length);
      applyActiveState(target);
      lockLightboxMove();
      lightboxSplide.go(target);
    };

    const suppressPointerDrag = (button) => {
      if (!button) return;
      const suppress = (event) => {
        event.stopPropagation();
      };
      button.addEventListener("pointerdown", suppress, { signal: gallerySignal });
      button.addEventListener("mousedown", suppress, { signal: gallerySignal });
      button.addEventListener("touchstart", suppress, { signal: gallerySignal, passive: true });
    };

    const galleryPrevButton = contentRoot.querySelector("[data-gallery-prev]");
    const galleryNextButton = contentRoot.querySelector("[data-gallery-next]");
    const lightboxPrevButton = contentRoot.querySelector("[data-lightbox-prev]");
    const lightboxNextButton = contentRoot.querySelector("[data-lightbox-next]");

    suppressPointerDrag(galleryPrevButton);
    suppressPointerDrag(galleryNextButton);
    suppressPointerDrag(lightboxPrevButton);
    suppressPointerDrag(lightboxNextButton);

    const applyActiveState = (index) => {
      const clamped = clampIndex(index, images.length);
      optionState.__galleryIndex = clamped;

      contentRoot.querySelectorAll(".product-gallery-dot").forEach((dot, i) => {
        dot.classList.toggle("is-active", i === clamped);
      });

      contentRoot.querySelectorAll("[data-lightbox-thumb]").forEach((thumb) => {
        const thumbIndex = Number(thumb.getAttribute("data-lightbox-thumb") || "0");
        thumb.classList.toggle("is-active", thumbIndex === clamped);
      });
    };

    mainSplide.on("mounted moved", () => {
      applyActiveState(mainSplide.index);
      unlockMainMove();
    });

    const mountLightboxAt = (index) => {
      if (!lightboxRoot) return null;

      if (lightboxSplide) {
        lightboxSplide.destroy();
        lightboxSplide = null;
      }

      if (lightboxRoot.__lmSplideInstance) {
        lightboxRoot.__lmSplideInstance.destroy();
        lightboxRoot.__lmSplideInstance = null;
      }

      lightboxSplide = new SplideCtor(lightboxRoot, {
        ...splideOptions,
        type: "slide",
        rewind: true,
        drag: false,
        start: clampIndex(index, images.length),
      });
      lightboxRoot.__lmSplideInstance = lightboxSplide;

      lightboxSplide.on("mounted moved", () => {
        if (!optionState.__lightboxOpen || !lightboxSplide) return;
        applyActiveState(lightboxSplide.index);
        unlockLightboxMove();
      });

      lightboxSplide.mount();
      return lightboxSplide;
    };

    mainSplide.mount();
    applyActiveState(startIndex);

    galleryPrevButton?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      goMainStep(-1);
    }, { signal: gallerySignal });

    galleryNextButton?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      goMainStep(1);
    }, { signal: gallerySignal });

    contentRoot.querySelectorAll("[data-gallery-thumb]").forEach((button) => {
      button.addEventListener("click", () => {
        const target = clampIndex(Number(button.getAttribute("data-gallery-thumb") || "0"), images.length);
        applyActiveState(target);
        if (optionState.__lightboxOpen && lightboxSplide) {
          lightboxSplide.go(target);
        } else {
          mainSplide.go(target);
        }
      }, { signal: gallerySignal });
    });

    contentRoot.querySelectorAll("[data-gallery-open]").forEach((button) => {
      button.addEventListener("click", () => {
        const target = clampIndex(Number(button.getAttribute("data-gallery-open") || "0"), images.length);
        optionState.__lightboxOpen = true;
        applyActiveState(target);
        lightboxWrap?.classList.add("show");
        requestAnimationFrame(() => {
          if (!optionState.__lightboxOpen) return;
          const opened = mountLightboxAt(target);
          if (!opened) return;

          // Re-assert target index after mount now that the lightbox has layout.
          opened.options = {
            ...opened.options,
            speed: 0,
            waitForTransition: false,
          };
          opened.go(target);
          requestAnimationFrame(() => {
            opened.options = {
              ...opened.options,
              speed: splideOptions.speed,
              waitForTransition: true,
            };
          });
        });
        setHomeFooterLabel("back to shop");
      }, { signal: gallerySignal });
    });

    contentRoot.querySelector("[data-lightbox-close]")?.addEventListener("click", () => {
      const currentIndex = lightboxSplide
        ? clampIndex(lightboxSplide.index, images.length)
        : clampIndex(optionState.__galleryIndex, images.length);

      if (lightboxSplide) {
        lightboxSplide.destroy();
        lightboxSplide = null;
        lightboxRoot.__lmSplideInstance = null;
      }

      applyActiveState(currentIndex);
      // Keep gallery state mirrored without visible motion when closing lightbox.
      mainSplide.options = {
        ...mainSplide.options,
        speed: 0,
        waitForTransition: false,
      };
      mainSplide.go(currentIndex);
      requestAnimationFrame(() => {
        mainSplide.options = {
          ...mainSplide.options,
          speed: splideOptions.speed,
          waitForTransition: true,
        };
      });
      optionState.__lightboxOpen = false;
      lightboxWrap?.classList.remove("show");
      setHomeFooterLabel(footerBackHomeLabel);
    }, { signal: gallerySignal });

    lightboxPrevButton?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (optionState.__lightboxOpen && lightboxSplide) {
        goLightboxStep(-1);
      } else {
        goMainStep(-1);
      }
    }, { signal: gallerySignal });

    lightboxNextButton?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (optionState.__lightboxOpen && lightboxSplide) {
        goLightboxStep(1);
      } else {
        goMainStep(1);
      }
    }, { signal: gallerySignal });

    contentRoot.querySelectorAll("[data-lightbox-thumb]").forEach((button) => {
      button.addEventListener("click", () => {
        const target = clampIndex(Number(button.getAttribute("data-lightbox-thumb") || "0"), images.length);
        applyActiveState(target);
        if (optionState.__lightboxOpen && lightboxSplide) {
          lightboxSplide.go(target);
        }
      }, { signal: gallerySignal });
    });
  }

  function bindDrawerForm(product, optionState) {
    const form = root.querySelector("#drawer-product-form");
    if (!form) return;
    const cartError = form.querySelector("[data-product-cart-error]");

    const setCartError = (message) => {
      if (!cartError) return;
      const text = String(message || "").trim();
      cartError.textContent = text;
      cartError.hidden = !text;
    };

    const selectedVariant = () => findVariant(product, optionState);
    const selectedVariantRule = () => getVariantQuantityRule(selectedVariant());

    form.querySelectorAll(".variant_option-button").forEach((button) => {
      button.addEventListener("click", function () {
        const optionWrap = button.closest("[data-option-name]");
        if (!optionWrap) return;
        const optionName = optionWrap.getAttribute("data-option-name");
        const optionIndex = Number(optionWrap.getAttribute("data-option-index") || "0");
        const value = button.getAttribute("data-option-value");
        optionState[optionName] = value;
        optionState[`__option${optionIndex + 1}`] = value;
        const nextRule = selectedVariantRule();
        optionState.__quantity = Math.max(nextRule.min, Number(optionState.__quantity || nextRule.min));
        renderProductDrawer(product, optionState);
      });
    });

    form.querySelectorAll("[data-quantity-change]").forEach((button) => {
      button.addEventListener("click", function () {
        const delta = Number(button.getAttribute("data-quantity-change")) || 0;
        const rule = selectedVariantRule();
        const stepDelta = delta > 0 ? rule.increment : -rule.increment;
        let nextQuantity = Math.max(rule.min, Number(optionState.__quantity || rule.min) + stepDelta);
        if (rule.max !== null) {
          nextQuantity = Math.min(nextQuantity, rule.max);
        }
        optionState.__quantity = nextQuantity;
        setCartError("");
        renderProductDrawer(product, optionState);
      });
    });

    form.addEventListener("submit", async function (event) {
      event.preventDefault();

      const variantId = form.querySelector('input[name="id"]')?.value;
      if (!variantId) return;

      const selectedVariant = findVariant(product, optionState);
      const rule = getVariantQuantityRule(selectedVariant);
      if (!isVariantPurchasableAtMinimum(selectedVariant, rule.min)) return;

      const quantity = Math.max(rule.min, Number(optionState.__quantity || rule.min));
      if (quantity < rule.min) {
        setCartError(`minimum order for this item is ${rule.min}.`);
        return;
      }

      setCartError("");
      setProductFormSubmitting(form, true);

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: Number(variantId),
            quantity,
          }),
        });

        if (!response.ok) {
          let description = "";
          try {
            const payload = await response.json();
            description = String(payload.description || payload.message || "").trim();
          } catch (e) {}
          throw new Error(description || "Unable to add to cart");
        }

        await refreshCartUI({ open: true });
      } catch (error) {
        console.error("Failed to add to cart", error);
        const message = String(error && error.message ? error.message : "").trim();
        if (message) {
          setCartError(message);
        } else {
          setCartError("unable to add this item right now. please try again.");
        }
      } finally {
        setProductFormSubmitting(form, false);
      }
    });
  }

  async function openProductDrawerByHandle(productHandle, sizeChartUrl) {
    if (!productPanel || !productDrawerContent || !productHandle) return;

    try {
      productPanel.classList.add("active");
      productPanel.setAttribute("aria-hidden", "false");
      setHomeFooterLabel("back to shop");
      showProductDrawerLoader();

      let product = loadedProductCache[productHandle];
      if (!product) {
        const response = await fetch(`/products/${encodeURIComponent(productHandle)}.js`);
        if (!response.ok) throw new Error(`Unable to load product ${productHandle}`);
        product = await response.json();
        loadedProductCache[productHandle] = product;
      }

      await preloadProductGalleryImages(product);

      const optionState = { __quantity: 1, __galleryIndex: 0, __sizeChartUrl: sizeChartUrl || "" };
      optionState.__sizeChartData = sizeChartDataMap.get(productHandle) || null;
      renderProductDrawer(product, optionState);
      await waitForDrawerImagesReady();
      hideProductDrawerLoader();
    } catch (error) {
      console.error(error);
      productDrawerContent.innerHTML = "<p>Unable to load product details.</p>";
      hideProductDrawerLoader();
      productPanel.classList.add("active");
      productPanel.setAttribute("aria-hidden", "false");
      setHomeFooterLabel("back to shop");
    }
  }

  function getNormalizedViewName(value) {
    const fallback = "home";
    if (!value) return fallback;
    const normalized = String(value).toLowerCase();
    if (!viewNames.has(normalized)) return fallback;
    return normalized;
  }

  function getCurrentViewName() {
    const active = root.querySelector("[data-view].show");
    const activeName = active ? active.getAttribute("data-view") : "";
    return getNormalizedViewName(activeName || "home");
  }

  function normalizePolicyTab(value) {
    const fallback = policyTabPanes[0] ? (policyTabPanes[0].getAttribute("data-policy-pane") || "") : "";
    if (!value) return fallback;
    const normalized = String(value).trim().toLowerCase();
    if (!policyTabIds.has(normalized)) return fallback;
    return normalized;
  }

  function getCurrentPolicyTab() {
    const activeTab = root.querySelector("[data-policy-tab].is-active");
    const activeValue = activeTab ? activeTab.getAttribute("data-policy-tab") : "";
    return normalizePolicyTab(activeValue);
  }

  function setActivePolicyTab(value) {
    const selected = normalizePolicyTab(value);
    if (!selected) return;

    policyTabButtons.forEach((button) => {
      const tab = (button.getAttribute("data-policy-tab") || "").toLowerCase();
      const isActive = tab === selected;
      button.classList.toggle("is-active", isActive);
      button.classList.toggle("w--current", isActive);
    });

    policyTabPanes.forEach((pane) => {
      const paneName = (pane.getAttribute("data-policy-pane") || "").toLowerCase();
      pane.classList.toggle("is-active", paneName === selected);
    });
  }

  function normalizeModalIds(input) {
    const values = Array.isArray(input)
      ? input
      : typeof input === "string"
        ? input.split(",")
        : [];

    return Array.from(
      new Set(
        values
          .map((value) => String(value || "").trim())
          .filter((value) => modalIds.has(value))
      )
    );
  }

  function getCurrentModalIds() {
    return Array.from(modals)
      .filter((modal) => !modal.hidden)
      .map((modal) => modal.id)
      .filter(Boolean);
  }

  function getCurrentProductHandle() {
    if (!productPanel || !productPanel.classList.contains("active")) return "";
    const contentWrapper = productDrawerContent ? productDrawerContent.querySelector(".product-content-wrapper[data-product-handle]") : null;
    const handle = contentWrapper ? contentWrapper.getAttribute("data-product-handle") : "";
    return handle || "";
  }

  function getCurrentSizeChartUrl() {
    if (!productPanel || !productPanel.classList.contains("active")) return "";
    const chartImage = productDrawerContent ? productDrawerContent.querySelector("[data-size-chart-modal] .size-chart__svg") : null;
    if (!chartImage) return "";
    return chartImage.getAttribute("src") || "";
  }

  function getCurrentUiState() {
    const productHandle = getCurrentProductHandle();
    const currentModals = getCurrentModalIds();
    return {
      view: productHandle ? "shop" : getCurrentViewName(),
      modals: productHandle ? [] : currentModals,
      product: productHandle,
      sizeChart: productHandle ? getCurrentSizeChartUrl() : "",
      policyTab: getCurrentPolicyTab(),
    };
  }

  function readRouteStateFromUrl() {
    const url = new URL(window.location.href);
    const product = (url.searchParams.get("product") || "").trim();
    const legacyModal = (url.searchParams.get("modal") || "").trim();
    const modalsParam = (url.searchParams.get("modals") || "").trim();
    const sizeChart = (url.searchParams.get("sizeChart") || "").trim();
    const policyTab = (url.searchParams.get("policyTab") || "").trim();

    let view = getNormalizedViewName(url.searchParams.get("view") || "home");
    if (product) view = "shop";

    const modals = normalizeModalIds(modalsParam || legacyModal);

    return {
      view,
      modals,
      product,
      sizeChart,
      policyTab: normalizePolicyTab(policyTab),
    };
  }

  function buildUrlFromRouteState(state) {
    const url = new URL(window.location.href);
    url.searchParams.delete("view");
    url.searchParams.delete("modal");
    url.searchParams.delete("modals");
    url.searchParams.delete("product");
    url.searchParams.delete("sizeChart");
    url.searchParams.delete("policyTab");

    const normalizedView = getNormalizedViewName(state.view || "home");
    if (normalizedView !== "home") {
      url.searchParams.set("view", normalizedView);
    }

    if (state.product) {
      url.searchParams.set("product", state.product);
      if (state.sizeChart) {
        url.searchParams.set("sizeChart", state.sizeChart);
      }
      const productModals = normalizeModalIds(state.modals);
      if (productModals.length) {
        url.searchParams.set("modals", productModals.join(","));
      }
      return `${url.pathname}${url.search}${url.hash}`;
    }

    const routeModals = normalizeModalIds(state.modals);
    if (routeModals.length) {
      url.searchParams.set("modals", routeModals.join(","));
    }

    if (normalizedView === "policy") {
      const selectedPolicyTab = normalizePolicyTab(state.policyTab);
      if (selectedPolicyTab) {
        url.searchParams.set("policyTab", selectedPolicyTab);
      }
    }

    return `${url.pathname}${url.search}${url.hash}`;
  }

  function setBrowserUrlFromState(state, replace) {
    const nextUrl = buildUrlFromRouteState(state);
    const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (nextUrl === currentUrl) return;

    const historyState = {
      view: state.view || "home",
      modals: normalizeModalIds(state.modals),
      product: state.product || "",
      sizeChart: state.sizeChart || "",
      policyTab: normalizePolicyTab(state.policyTab),
    };

    if (replace) {
      window.history.replaceState(historyState, "", nextUrl);
      return;
    }

    window.history.pushState(historyState, "", nextUrl);
  }

  async function applyRouteState(inputState, options = {}) {
    const token = ++navigationToken;
    const state = {
      view: getNormalizedViewName(inputState && inputState.view ? inputState.view : "home"),
      modals: normalizeModalIds(
        inputState && inputState.modals !== undefined
          ? inputState.modals
          : inputState && inputState.modal
            ? inputState.modal
            : []
      ),
      product: inputState && inputState.product ? String(inputState.product) : "",
      sizeChart: inputState && inputState.sizeChart ? String(inputState.sizeChart) : "",
      policyTab: normalizePolicyTab(
        inputState && inputState.policyTab !== undefined
          ? inputState.policyTab
          : getCurrentPolicyTab()
      ),
    };

    if (state.product) {
      state.view = "shop";
    }

    closeOpenModules();
    showView(state.view);
    setActivePolicyTab(state.policyTab);

    hideAllModals();
    state.modals.forEach((modalId) => showModal(modalId));

    if (state.product) {
      await openProductDrawerByHandle(state.product, state.sizeChart || "");
      if (token !== navigationToken) return;
    }

    if (!options.skipHistory) {
      setBrowserUrlFromState(state, Boolean(options.replaceHistory));
    }
  }

  function syncUrlToCurrentUiState(options = {}) {
    const state = getCurrentUiState();
    setBrowserUrlFromState(state, Boolean(options.replaceHistory));
  }

  function inferViewFromEditorSelection(node) {
    if (!node || !(node instanceof Element)) return "";

    if (node.matches("[data-view]")) {
      return getNormalizedViewName(node.getAttribute("data-view"));
    }

    const viewRoot = node.querySelector("[data-view]");
    if (viewRoot) {
      return getNormalizedViewName(viewRoot.getAttribute("data-view"));
    }

    return "";
  }

  function openEditorSelectedView(event) {
    const selectedNode = event && event.target ? event.target : null;
    const view = inferViewFromEditorSelection(selectedNode);
    if (!view) return;

    applyRouteState(
      {
        view,
        modals: getCurrentModalIds(),
        policyTab: getCurrentPolicyTab(),
      },
      { skipHistory: true }
    );
  }

  root.querySelectorAll("[data-open-view]").forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      const target = button.getAttribute("data-open-view");

      if (
        button.id === "home__button-footer" &&
        (forceMobileDeviceLayout || window.matchMedia("(max-width: 1024px)").matches) &&
        productPanel &&
        productPanel.classList.contains("active")
      ) {
        closeCurrentLightbox();
        closeProductDrawer();
        syncUrlToCurrentUiState();
        return;
      }

      if (button.id === "home__button-footer" && isLightboxOpen()) {
        closeCurrentLightbox();
        return;
      }
      const policyTab = button.getAttribute("data-policy-tab") || undefined;
      applyRouteState({ view: target || "home", modals: getCurrentModalIds(), policyTab });
    });
  });

  initDraggableModals();
  initHomeModalMouseParallax();
  syncMobileProductThumbnails();
  window.addEventListener("resize", syncMobileProductThumbnails);
  initCart();

  if (homeButtonWrap) {
    homeButtonWrap.addEventListener("click", function () {
      closeCurrentLightbox();
      applyRouteState({ view: "home", modals: getCurrentModalIds() });
    });
  }

  root.querySelectorAll("[data-open-modal]").forEach((button) => {
    button.addEventListener("click", function () {
      const target = button.getAttribute("data-open-modal");
      if (!target) return;
      const currentModals = getCurrentModalIds();
      const isOpen = currentModals.includes(target);
      const nextModals = isOpen
        ? normalizeModalIds(currentModals.filter((modalId) => modalId !== target))
        : normalizeModalIds([...currentModals, target]);
      applyRouteState({ view: getCurrentViewName(), modals: nextModals });
    });
  });

  root.querySelectorAll("[data-close-modal]").forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      const target = button.getAttribute("data-close-modal");
      if (!target) return;

      const nextModals = normalizeModalIds(
        getCurrentModalIds().filter((modalId) => modalId !== target)
      );
      applyRouteState({ view: getCurrentViewName(), modals: nextModals });
    });
  });

  root.querySelectorAll("#productDrawerClose").forEach((btn) => {
    btn.addEventListener("click", function () {
      closeProductDrawer();
      syncUrlToCurrentUiState();
    });
  });

  productCards.forEach((card) => {
    let touchPointerId = null;
    let touchStartX = 0;
    let touchStartY = 0;
    let lastTouchOpenAt = 0;

    function openCard() {
      const handle = card.getAttribute("data-product-handle");
      if (!handle) return;
      const sizeChartUrl = card.getAttribute("data-size-chart-url") || "";
      applyRouteState({ view: "shop", modals: getCurrentModalIds(), product: handle, sizeChart: sizeChartUrl });
    }

    card.addEventListener("click", function () {
      if (Date.now() - lastTouchOpenAt < 700) return;
      openCard();
    });

    card.addEventListener("pointerdown", function (event) {
      if (event.pointerType !== "touch") return;
      touchPointerId = event.pointerId;
      touchStartX = event.clientX;
      touchStartY = event.clientY;
    });

    card.addEventListener("pointerup", function (event) {
      if (event.pointerType !== "touch") return;
      if (touchPointerId !== event.pointerId) return;

      const deltaX = Math.abs(event.clientX - touchStartX);
      const deltaY = Math.abs(event.clientY - touchStartY);
      touchPointerId = null;

      if (deltaX > 10 || deltaY > 10) return;
      lastTouchOpenAt = Date.now();
      openCard();
    });

    card.addEventListener("pointercancel", function () {
      touchPointerId = null;
    });

    card.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      openCard();
    });
  });

  const dropdown = root.querySelector("#tagFilter");
  if (dropdown) {
    dropdown.addEventListener("change", function (event) {
      const selected = String(event.target.value || "all").toLowerCase();

      productCards.forEach((card) => {
        const tags = String(card.getAttribute("data-product-tags") || "").toLowerCase();
        const matches = selected === "all" || tags.split(",").includes(selected);
        const gridItem = card.closest(".w-dyn-item, [role='listitem']") || card;
        gridItem.style.display = matches ? "" : "none";
      });
    });
  }

  policyTabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const tab = button.getAttribute("data-policy-tab");
      applyRouteState({ view: "policy", modals: getCurrentModalIds(), policyTab: tab || "" });
    });
  });


  initWaitlistSignupForm();
  initEventBarDismiss();

  window.addEventListener("popstate", function () {
    applyRouteState(readRouteStateFromUrl(), { skipHistory: true });
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:select", openEditorSelectedView);
    document.addEventListener("shopify:block:select", openEditorSelectedView);
  }

  applyRouteState(readRouteStateFromUrl(), { replaceHistory: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initLongmouthTheme, { once: true });
} else {
  initLongmouthTheme();
}
